import { LexicalComposer } from "@lexical/react/LexicalComposer";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import React, { useCallback, useEffect, useRef, useState } from "react";
import Modal from "@mui/material/Modal";
import BackButton from "../../../../../../../../components/BackButton/BackButton";
import CommonTextField from "../../../../../../../../utils/CommonTextField";
import {
  checkifDateisAfterToday,
  isRequired,
} from "../../../../../../../../utils/validator";
import ass_img from "../../../../../../../../assets/images/ass-img.png";
import Calimg from "../../../../../../../../assets/images/calendar.png";
import go_btn from "../../../../../../../../assets/images/go-btn-img.png";
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import "./Styles/lessonGeneratorTablet.css";
import dayjs from "dayjs";
import { format } from "date-fns";
import moment from "moment";
import { Tooltip } from "react-tooltip";
import {
  Box,
  FormControl,
  FormHelperText,
  ListItem,
  ListItemIcon,
  ListItemText,
  MenuItem,
  TextField,
  Tooltip as MuiTooltip,
  CircularProgress,
} from "@mui/material";
import { useTheme } from "styled-components";
import { useNewLessons } from "../NewLessonContext";
import {
  addLineBreaksAroundImages,
  defaultWorkboardContent,
  getFileIcon,
  getFileType,
  handleassignmentnameKeyPress,
  normalizeLatexToDoubleDollar,
  Placeholder,
} from "../utils/fileHelpers";
import PreprocessAndRenderLatex from "../../../../../../../../components/ProcessRenderLatex";
import LoaderComponent from "../../../../../../../../components/LoaderComponent/LoaderComponent";
import AudioPlayer from "../../../../../../../../components/AudioPlayer/AudioPlayer";
import UpdatePlugin from "../childs/UpdateToEditor";
import {
  formatLatexInHtmlTags,
  processLatex,
} from "../../../../../../../../utils/PreProcessorLatexCode";
import AWSS3FileDelete from "../../../../../../../../components/AWSFileUpload/AWSS3FileDelete";
import { AssignmentType, GenerationType } from "../../../../../../../../utils/consts";
import FileUpload from "../../../../../../../../components/FileUploadToS3/FileUpload";
import { AttachFileOutlined } from "@mui/icons-material";
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
import { UpdateActiveWorkbaordPlugin } from "../UpdateActiveWorkboardPlugin/UpdateActiveWorkboard";
import GoogleDocFile from "../../google_docs";
import ToolbarPlugin from "../../../../../editor/plugins/ToolbarPlugin";
import { RichTextPlugin } from "@lexical/react/LexicalRichTextPlugin";
import { ContentEditable } from "@lexical/react/LexicalContentEditable";
import { useNavigate } from "react-router";
import {
  $getRoot,
  $insertNodes,
  $createParagraphNode,
  $createTextNode,
} from "lexical";
import { marked } from "marked";
import { $generateNodesFromDOM } from "@lexical/html";
import { ClearEditorPlugin } from "@lexical/react/LexicalClearEditorPlugin";
import { HistoryPlugin } from "@lexical/react/LexicalHistoryPlugin";
import { LinkPlugin } from "@lexical/react/LexicalLinkPlugin";
import { ListPlugin } from "@lexical/react/LexicalListPlugin";
import { MarkdownShortcutPlugin } from "@lexical/react/LexicalMarkdownShortcutPlugin";
import PastePlugin from "../../../../../editor/plugins/PastePlugin.js";
import { TRANSFORMERS } from "@lexical/markdown";
import { AutoFocusPlugin } from "@lexical/react/LexicalAutoFocusPlugin";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import HtmlPlugin from "../../../../../editor/plugins/HtmlPlugin.tsx";
import AutoLinkPlugin from "../../../../../editor/plugins/AutoLinkPlugin";
import ImageDeletePlugin from "../../../../../editor/plugins/ImageDeletePlugin.js";
import CodeHighlightPlugin from "../../../../../editor/plugins/CodeHighlightPlugin";
import ListMaxIndentLevelPlugin from "../../../../../editor/plugins/ListMaxIndentLevelPlugin";
import {
  Course_created_successfully_image,
  tooltip,
  preview,
  information,
  YouTube_Logo,
} from "../../../../../../../../assets/images/images.ts";
import LoadingGenerationComponent from "../../LoadingGenerationComponent .jsx";
import api, { liveBaseURL, wsURL } from "../../../../../../../../../src/api/api.js";
import UploadFromRepoModal from "../../../../../../../../components/FileUploadToS3/UploadFromRepoModal.jsx";
import SelectedFiles from "../../../../../../../../components/FileRepo/Components/LessonGenerator/SelectedFiles.jsx";
import { ai_feedback_image } from "../../../../../../../../assets/images/images.ts";
import { book_animate } from "../../../../../../../../assets/images/images.ts";
import { useModal } from "../../../../../../../../components/FileRepo/hooks/useModal";
import ProfileModal from "../../../../../../../../components/FileRepo/FileActions/ProfileModal";
import UploadFileBtn from "../../../../../../../../components/FileRepo/Components/Buttons/UploadFileBtn.jsx";
import IframeDeletePlugin from "../../IframeDeletePlugin.js";
import { useAuth } from "../../../../../../../../features/auth/AuthContext.js";
import YoutubeLink from "../../../../../../../../components/FileUploadToS3/YoutubeLink.js";
import GenerationTypeMenu from "./GenerationTypeMenu.jsx";
import StorySetup from "./StorySetup.jsx";
import StoryPreview from "./StoryPreview.jsx";
import PrimaryBtn from "../../../../../../../../components/Buttons/PrimaryBtn.jsx";
import { EyeIcon } from "../../../../student/Icons/Icons.jsx";
import GenerationTypePopup from "./GenerationTypePopup.jsx";
import { splitPendingImages, splitTrailingPartial } from "../utils/lessonImagePlaceholder.js";
import {
  getYoutubeVideoId,
  playYoutubeAt,
  withYoutubeJsApi,
  ytSecondsFromUrl,
} from "../../youtubePlayer.js";


const GENERATE_ALL_STATUS_MESSAGES = [
  "Analysing the input...",
  "Fetching the database Schema...",
  "Generating Query...",
  "Fetching course data...",
  "Getting a response..."
];

const EMPTY_LESSON_PLACEHOLDER_DESCRIPTION = "@$%^231#^#a5fgd%532^&4R3&";

;




function insertGenerateAllRubricIntoEditor(editor, content, { isHtml = false } = {}) {
  const root = $getRoot();
  root.clear();
  const parser = new DOMParser();



  if (!content) return;

  if (isHtml) {
    try {
      const dom = parser.parseFromString(content, "text/html");
      const nodes = $generateNodesFromDOM(editor, dom);
      $insertNodes(nodes);
    } catch (error) {
      console.error("GenerateAllLessonEditorPlugin HTML insert:", error);
      const p = $createParagraphNode();
      p.append($createTextNode(content));
      root.append(p);
    }
    return;
  }

  const addNewLine = addLineBreaksAroundImages(content);
  const preprocessedText = normalizeLatexToDoubleDollar(addNewLine);
  const sections = preprocessedText?.split(/\$\$/) || [];

  const processedSections = sections.map((section, index) => {
    if (index % 2 === 1) {
      if (!section || section.trim() === "") {
        return "";
      }
      const escapedSection = section
        .replace(/</g, " \\lt ")
        .replace(/>/g, " \\gt ");
      return `<p>$$${escapedSection}$$</p>`;
    }
    return marked(section);
  });

  const finalAnswer = processedSections
    .join("")
    .replace("<STARTOFTURN>", "")
    .replace("<ENDOFTURN>", "");

  const mergedContent = finalAnswer
    .replace(
      /<\/p>\s*<span>(\$\$[^$]*?\$\$)<\/span>\s*<p>/gi,
      (match, latexContent) => `</p><p><span>${latexContent}</span>`,
    )
    .replace(
      /<\/p>\s*<span>(\$\$[^$]*?\$\$)<\/span>\s*(<h[1-6]|<\/h[1-6]|<ul|<\/ul|<ol|<\/ol)/gi,
      (match, latexContent, nextTag) =>
        `<p><span>${latexContent}</span></p>${nextTag}`,
    )
    .replace(
      /(<\/h[1-6]|<\/ul|<\/ol)\s*<span>(\$\$[^$]*?\$\$)<\/span>\s*<p>/gi,
      (match, closingTag, latexContent) =>
        `${closingTag}<p><span>${latexContent}</span></p><p>`,
    )
    .replace(
      /<\/p>\s*<span>(\$\$[^$]*?\$\$)<\/span>\s*<\/p>/gi,
      (match, latexContent) => `<p><span>${latexContent}</span></p>`,
    );

  const processedContent = formatLatexInHtmlTags(mergedContent);
  const dom = parser.parseFromString(processedContent, "text/html");
  const nodes = $generateNodesFromDOM(editor, dom);

  try {
    $insertNodes(nodes);
  } catch (error) {
    console.error("GenerateAllLessonEditorPlugin markdown insert:", error);
    root.clear();
    const p = $createParagraphNode();
    p.append($createTextNode(content));
    root.append(p);
  }
}

/** Inserts rubric into Lexical after create-rubric API (not on WS chunk). */
function GenerateAllLessonEditorPlugin({
  generateAllMode,
  ganrateLesson,
  generateAllRubricEditorSync,
  setGenerateAllRubricEditorSync,
  setGenerateAllMode,
  setShowCourseSuccessfully,
  TabToBottom,
  activeWorkboard,
}) {
  const [editor] = useLexicalComposerContext();
  const rubricEditorSyncedRef = useRef(false);
  const lastSyncIdRef = useRef(null);

  useEffect(() => {
    if (generateAllMode) {
      rubricEditorSyncedRef.current = false;
      lastSyncIdRef.current = null;
    }
  }, [generateAllMode]);

  useEffect(() => {
    if (!generateAllRubricEditorSync?.html) return;
    if (ganrateLesson) return;
    if (activeWorkboard?.name !== "Rubric") return;

    const { html, isHtml, id } = generateAllRubricEditorSync;

    if (id != null) {
      lastSyncIdRef.current = id;
      rubricEditorSyncedRef.current = false;
    }
    if (rubricEditorSyncedRef.current) return;
    rubricEditorSyncedRef.current = true;

    const frameId = requestAnimationFrame(() => {
      editor.update(() => {
        insertGenerateAllRubricIntoEditor(editor, html, { isHtml: !!isHtml });
        $getRoot().select();
      });
      queueMicrotask(() => {
        TabToBottom?.();
        setGenerateAllRubricEditorSync?.(null);
        setShowCourseSuccessfully(true)
        setTimeout(() => {
          setShowCourseSuccessfully(false)
          setGenerateAllMode?.(false);

        }, 3000)
      });
    });

    return () => cancelAnimationFrame(frameId);
  }, [
    generateAllMode,
    ganrateLesson,
    editor,
    generateAllRubricEditorSync,
    setGenerateAllRubricEditorSync,
    setGenerateAllMode,
    TabToBottom,
    activeWorkboard?.name,
  ]);

  return null;
}


export const LessonGenerator = () => {
  const navigate = useNavigate();
  const {
    isLessonSocketReady,
    lesson,
    formState,
    setFormState,
    formLessonError,
    editorConfig,
    chatHist,
    isChatHistLoading,
    selectedFiles,
    setSelectedFiles,
    progressTracker,
    setprogressTracker,
    reFormatterLoading,
    showScrollButton,
    messagesEndRef,
    handleInputChange,
    TabToBottom,
    minDate,
    isValidDateAssignmentStartDate,
    isValidDateAssignmentEndDate,
    isValidDateLessonStartDate,
    isValidDateLessonEndDate,
    formAssignmentState,
    setFormAssignmentState,
    formErrorAssignmentState,
    setFormErrorAssignmentState,
    lessonMinDate,
    course,
    handleInputChangedate,
    pop_up_for_lesson_start_date_note,
    lesson_id,
    isLessonSaved,
    isLockedBySubmissions,
    SUBMISSION_LOCKED_MESSAGE,
    isSmallScreen,
    activeTab,
    setActiveTab,
    isSwitchOnVirtualAssistant,
    handleSwitchToggleVirtualAssistant,
    Assignmentgeneration,
    handleSwitchToggleDownload,
    handleSwitchToggleLessonPreview,
    isSwitchOn2,
    isSwitchOnLessonPreview,
    handleScrollClick,
    isWorkboardEmpty,
    getname,
    globalState,
    generateAIVoice,
    texttospeech,
    chatAudioId,
    onCopyClicked,
    workboardText,
    activeWorkboard,
    setActiveWorkboard,
    editorActiveWorkboardNameRef,
    syncEditorActiveWorkboardName,
    workboards,
    isAssignment,
    setIsAssignment,
    isRubric,
    setIsRubric,
    uploadedFileLink,
    setuploadedFileLink,
    fileInputRef,
    sendGenerateLession,
    closeConnection,
    showCloseBTN,
    ganrateLesson,
    generateAllMode,
    isPopupVisible,
    showPopup,
    setPopupVisible,
    SkipLessonflag,
    setskipLessonflag,
    isSwitchOn,
    checkAssignmentopen,
    handleAssignmentInputChange,
    assignmentDurationChangeTime,
    assignmentDuration,
    setAssignmentDuration,
    setAssignmentDurationCount,
    assignmentDurationCount,
    handleAssignmentInputChangedate,
    showUploadPop,
    setShowUploadPop,
    textBoxRef,
    showUploadPopupcall,
    isListening,
    transcript,
    startStopListening,
    handleInputKeyPress,
    showstudentviewDtls,
    previesAssignment,
    previesRubric,
    eachAssignment_id,
    eachRubric_id,
    defaultWorkboardData,
    globleSaveData,
    getassignmentdetails,
    assignmentsCountTwo,
    rubricCounttTwo,
    setGlobleOnChangeDataSave,
    setClickSaveBTN,
    setClickSaveRubricBTN,
    updateDefaultWorkboardData,
    setPreviesAssignment,
    setPreviesRubric,
    setEachAssignment_id,
    setEachRubric_id,
    setassignment_id,
    setrubric_id,
    isRequired,
    handleSwitchToggle,
    isSaveChecker,
    switchschoologySync,
    setswitchschoologySync,
    handleAssinmentRubricSubmit,
    globleOnChangeDataSave,
    clickSaveBTN,
    clickSaveRubricBTN,
    showCourseSuccessfully,
    loadingPublishSchoology,
    setAssignmentCountsTwo,
    setRubricCountTwo,
    disabledRubric,
    assignmentsCount,
    setAssignmentCounts,
    showAssingment,
    selectedAssignment,
    setShowAssingment,
    setSelectedAssignment,
    onChangeAssignmentData,
    setOnChangeAssignmentData,
    editWorkboardStatues,
    setEditWorkboardStatues,
    rubricCount,
    setRubricCount,
    onChangeRubricData,
    setOnChangeRubricData,
    selectedRubric,
    setSelectedRubric,
    showDropdownRubric,
    setShowDropdownRubric,
    updateFuntion,
    setUpdateFuntion,
    isRubricConfirmModalData,
    setIsRubricConfirmModalData,
    isAssingmentConfirmModalData,
    setIsAssingmentConfirmModalData,
    afterConfirmation,
    setAfterConfirmation,
    callAddAssignmentFun,
    setCallAddAssignmentFun,
    callSwitchToRubricFun,
    setCallSwitchToRubricFun,
    pendingAssignmentClickArgs,
    setPendingAssignmentClickArgs,
    updateWorkboardDataByName,
    lessonbuttonStyle,
    globleOnChange,
    setGlobleOnChange,
    updateGlobleOnChangeData,
    setShowRubricPopUp,
    showDropdown,
    setShowDropdown,
    showDownloadFile,
    openModal,
    modalRef,
    modalContentRef,
    fileNameError,
    fileNameDownload,
    toggledownlodefile,
    exportToWord,
    handleFileNameChange,
    getschoologystatus,
    setschoologystatus,
    showInputTooltip,
    setShowInputTooltip,
    latextextvalue,
    setLatextextvalue,
    oldMathNode,
    setOldMathNode,
    oldnodeeditor,
    reFormatterData,
    setReFormatterData,
    handleEnhanceText,
    OnChangeRubricPlugin,
    OnChangePlugin,
    handleSwitchToggleSchoologySync,
    showloading,
    setskipLesson,
    handleForm1Submit,
    isNotSavePopUp,
    LessonSkipComponent,
    showLesson,
    handleUserScroll,
    chatContainerRef,
    setskipLessonSession,
    location,
    handleSwitchToggleHideTimer,
    currentHideTimerState,
    handleSaveHideTimer,
    setSelectedRepoFiles,
    selectedRepoFiles,
    handleGenerateAll,
    generateAllRubricEditorSync,
    setGenerateAllRubricEditorSync,
    setGenerateAllMode,
    setShowCourseSuccessfully,
    toggleLoader,
    skipLessonSession,
    getArraySectionData,
    cleanHtml,
    getSectionData,
    setIsSaveLoading,
    isSaveLoading,
    myRole,
    setYoutubeLinks,
    youtubeLinks,
    getSavedYoutubeLinks,
    stopGenerateAllMode,
    createManuallyMode,
    setCreateManuallyMode,
    generationType,
    setGenerationType,
    downloadLoading,
    typeChanged,
    setTypeChanged,
    setGetSpecificAssignmentType,
    generateImageOpen,
    setGenerateImageOpen,
    defaultYoutubeLink
  } = useNewLessons();

  const popupRef = useRef(null);






  const normalize = (str) => str?.replace(/\s*dir=\\?"ltr\\?"/g, '') ?? '';


  const { modal, reqData, openModal: openRepoModal, closeModal } = useModal();
  const { token } = useAuth();


  const [uploadFromRepo, setUploadFromRepo] = useState(false);

  const [isStoryPreviewOpen, setIsStoryPreviewOpen] = useState(false);  /** Student Preview modal — story generation only. */

  /** Preview needs a lesson that has actually been saved, not just created. */
  const isStoryPreviewAvailable = Boolean(lesson_id) && isLessonSaved;

  /**
   * One-off nudge toward the Student Preview: raised the moment a save makes
   * the preview available, and dismissed for good the first time the teacher
   * opens the preview — after that they know where it lives.
   */
  const [showStoryPreviewHint, setShowStoryPreviewHint] = useState(false);
  const wasStoryPreviewAvailable = useRef(isStoryPreviewAvailable);
  const storyPreviewBtnRef = useRef(null);

  useEffect(() => {
    if (generationType !== GenerationType.STORY.value) return;
    // Only the unsaved -> saved transition counts; a lesson that was already
    // saved when the teacher opened it should not nag them again.
    if (isStoryPreviewAvailable && !wasStoryPreviewAvailable.current) {
      setShowStoryPreviewHint(true);
    }
    wasStoryPreviewAvailable.current = isStoryPreviewAvailable;
  }, [isStoryPreviewAvailable, generationType]);

  /**
   * The button sits below the fold after a save, so bring it — and the tooltip
   * pointing at it — into view rather than hinting off-screen. The save
   * response re-renders the editor, so let that layout settle first, otherwise
   * the button moves out from under the scroll.
   */
  useEffect(() => {
    if (!showStoryPreviewHint) return;

    const timer = setTimeout(() => {
      storyPreviewBtnRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }, 500);

    return () => clearTimeout(timer);
  }, [showStoryPreviewHint]);


  /**
   * The "No content generated yet" prompt is an empty state: it stays up until
   * there is a lesson response, and goes the moment the teacher sends a prompt
   * and generation starts (chatHist gets the entry / ganrateLesson flips).
   */
  // const shouldShowGenerationTypePopup =
  //   generationType !== GenerationType.STORY.value &&
  //   lesson.description === EMPTY_LESSON_PLACEHOLDER_DESCRIPTION &&
  //   !(chatHist?.length > 0) &&
  //   !ganrateLesson &&
  //   !generateAllMode &&
  //   !createManuallyMode &&
  //   !stopGenerateAllMode;

  /**
   * A lesson that already has chat is no longer "empty", even if the teacher
   * never saved: they prompted, got an answer, walked away and came back. The
   * saved-lesson checks below can't see that, because an unsaved lesson still
   * carries the placeholder description and `createManuallyMode` is gone after
   * the remount — only the fetched history remembers it.
   *
   * Reading it here is safe during Generate All: `generateAllMode` gates the
   * branch below, so the streaming answers landing in `chatHist` swap the
   * generating animation for the editor only once that run is over.
   */
  const hasLessonConversation = chatHist?.length > 0;

  const shouldShowEmptyLessonPrompt =
    generationType !== GenerationType.STORY.value &&
    lesson.description === EMPTY_LESSON_PLACEHOLDER_DESCRIPTION &&
    !isChatHistLoading &&
    !hasLessonConversation &&
    !generateAllMode &&
    !createManuallyMode &&
    !stopGenerateAllMode;

  useEffect(() => {
    if (hasLessonConversation) {
      setCreateManuallyMode(true)
    }

  }, [hasLessonConversation])


  /**
   * Story Setup collects what the story websocket needs. It doubles as the
   * story empty state (it comes up on its own for a lesson with nothing in the
   * chat yet) and as a re-openable popup: picking "Story Generation" in the
   * type menu brings it back every time, even when story is already the
   * selected type, so the setup can be redone before another run.
   */
  const [isStorySetupOpen, setIsStorySetupOpen] = useState(
    () =>
      generationType === GenerationType.STORY.value && !(chatHist?.length > 0),
  );

  /**
   * True once the teacher opens the card from the type menu. That is a
   * deliberate re-open, not an empty state, so the auto-close below leaves it
   * alone.
   */
  const storySetupOpenedFromMenuRef = useRef(false);

  const closeStorySetup = useCallback(() => {
    storySetupOpenedFromMenuRef.current = false;
    setIsStorySetupOpen(false);
  }, []);

  /**
   * An existing lesson loads its chat after mount, so the auto-opened card has
   * to step aside the moment messages arrive — it only stands in for an empty
   * thread.
   */
  useEffect(() => {
    if (!(chatHist?.length > 0)) return;
    if (storySetupOpenedFromMenuRef.current) return;
    setIsStorySetupOpen(false);
  }, [chatHist?.length]);

  /**
   * With messages already on screen the card floats above the thread instead of
   * standing in for it — see `.story-setup-anchor` in storysetup.css.
   */
  const isStorySetupFloating = chatHist?.length > 0;

  const shouldShowStorySetup =
    generationType === GenerationType.STORY.value &&
    isStorySetupOpen &&
    !ganrateLesson;

  /** Hitting send is the teacher's "done" — the setup stays closed after it. */
  useEffect(() => {
    if (ganrateLesson) closeStorySetup();
  }, [ganrateLesson, closeStorySetup]);

  const isGenerationTypeLocked =
    // chatHist?.length > 0 ||
    ganrateLesson ||
    generateAllMode ||
    isLockedBySubmissions;

  // Once saved, the menu still opens but only the saved type stays selectable.
  const savedGenerationTypeMessage = isLessonSaved
    ? "Generation type cannot be changed once the lesson is saved"
    : undefined;

  // The generation-type chip sits inside the prompt field, so the textarea has
  // to reserve room for it only while the chip is actually rendered.
  const showGenerationTypeMenu =
    !(showCloseBTN || generateAllMode) &&
    globalState?.enabled_modules?.includes("lowerSchool") &&
    !generateImageOpen &&
    !isAssignment &&
    !isRubric;

  const [isLeftPanelOpen, setIsLeftPanelOpen] = useState(generationType === GenerationType?.STORY?.value ? true :
    () => lesson?.description !== EMPTY_LESSON_PLACEHOLDER_DESCRIPTION,
  );

  /**
   * That initial value is decided before the chat request comes back, so a
   * lesson whose only content is an unsaved conversation mounts with the panel
   * shut. Open it once the history lands — but only once: the ref keeps a
   * teacher who then closes the panel from having it reopened under them.
   */
  const didOpenPanelForHistoryRef = useRef(false);
  useEffect(() => {
    if (didOpenPanelForHistoryRef.current) return;
    if (isChatHistLoading || !hasLessonConversation) return;
    didOpenPanelForHistoryRef.current = true;
    setIsLeftPanelOpen(true);
  }, [isChatHistLoading, hasLessonConversation]);

  const hasRestrictedChars = /[+%&#]/.test(formState.name || "");
  const hasRestrictedCharsAssignment = /[+%&#]/.test(formAssignmentState.name || "");

  const handleLessonNameChange = (event) => {
    // let the value through so the user sees what they typed;
    // the error below + save-button guard block submission
    handleInputChange(event);
  };

  const handleBack = () => {

    sessionStorage.getItem("newlesson")
    // ? navigate(-1)
    // : navigate(
    //   `/course/${location.state?.course?.course_id}/view`,
    //   {
    //     state: {
    //       course: location.state?.course,
    //       teacher_id: location.state?.teacher_id,
    //     },
    //   },
    // )
    navigate(
      `/course/${location.state?.course?.course_id}/view`,
      {
        state: {
          course: location.state?.course,
          teacher_id: location.state?.teacher_id,
        },
      },
    )
  }

  useEffect(() => {
    if (lesson_id !== "") {
      setCreateManuallyMode(false);
    }
  }, [lesson_id]);

  const bodyRef = useRef(null);
  const [panelWidth, setPanelWidth] = useState(() => {
    return typeof window !== "undefined" ? Math.floor(window.innerWidth / 2) : 600;
  });

  useEffect(() => {
    if (!bodyRef.current) return;
    const ro = new ResizeObserver(entries => {
      const w = entries[0].contentRect.width;
      setPanelWidth(Math.floor(w / 2)); // left panel = 50% of parent
    });
    ro.observe(bodyRef.current);
    return () => ro.disconnect();
  }, []);



  // Add this derived value wherever isSaveChecker / save button disabled logic lives
  const isHideTimerChanged =
    isAssignment &&
    getassignmentdetails?.[assignmentsCountTwo] !== undefined &&
    currentHideTimerState !==
    (getassignmentdetails[assignmentsCountTwo]?.hide_timer || false);

  const isSkipLesson = sessionStorage.getItem("skipLesson") === "true";

  // on Assignment workboard OR skip-lesson flow, allow Hide Timer
  const isAssignmentContext =
    isAssignment || activeWorkboard?.name === "Assignment" || isSkipLesson;

  const isAssignmentSubmittedByStudent = getassignmentdetails[assignmentsCountTwo]?.assignment_completed_at;

  const hideTimerDisabled =
    (!isSkipLesson && Assignmentgeneration) || !isAssignmentContext || isAssignmentSubmittedByStudent != null;
  const wasEditingRef = useRef(false);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        showUploadPop &&
        popupRef.current &&
        !popupRef.current.contains(event.target)
      ) {
        setShowUploadPop(false); // close popup
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showUploadPop]);

  const [currentMessageIndex, setCurrentMessageIndex] = useState(0);

  useEffect(() => {
    if (!ganrateLesson || !generateAllMode) {
      setCurrentMessageIndex(0);
      return;
    }
    const interval = setInterval(() => {
      setCurrentMessageIndex(
        (prev) => (prev + 1) % GENERATE_ALL_STATUS_MESSAGES.length,
      );
    }, 2000);

    return () => clearInterval(interval);
  }, [ganrateLesson, generateAllMode]);

  const shouldShowPreview =
    createManuallyMode ||
    (
      (
        lesson.description !== EMPTY_LESSON_PLACEHOLDER_DESCRIPTION ||
        hasLessonConversation
      ) &&
      !generateAllMode
    );


  useEffect(() => {
    // Story generation always stays on the lesson tab — the workboard switcher
    // isn't rendered there, so flipping away from it leaves nothing to switch back.
    if (generationType === GenerationType.STORY.value) return;
    if (
      isSmallScreen &&
      lesson.description === EMPTY_LESSON_PLACEHOLDER_DESCRIPTION &&
      !hasLessonConversation &&
      !generateAllMode &&
      !createManuallyMode
    ) {
      setActiveTab("workboard");
    }
  }, [
    isSmallScreen,
    lesson.description,
    hasLessonConversation,
    generateAllMode,
    createManuallyMode,
    generationType,
  ]);

  const changeGenerationType = (value) => {
    if (value !== GenerationType?.STORY?.value) {
      setCreateManuallyMode(true);
      setskipLessonSession(true);
      closeStorySetup();
    } else {
      // Every pick of story re-opens the setup. `setGenerationType` is a no-op
      // when story is already selected, so the popup can't hang off that.
      storySetupOpenedFromMenuRef.current = true;
      setIsStorySetupOpen(true);
    }
    setGenerationType(value)
  }
  return (
    <div style={{ position: "relative" }}>
      {!isLessonSocketReady && (
        <div
          style={{
            position: "absolute",
            inset: 0,
            zIndex: 100,
            backgroundColor: "rgba(255, 255, 255, 0.92)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            gap: 16,
          }}
          aria-busy="true"
          aria-live="polite"
        >
          <LoaderComponent />
          <span style={{ fontSize: 14, color: "#555", marginBottom: "38px" }}>
            Connecting to lesson…
          </span>
        </div>
      )}
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <LexicalComposer initialConfig={editorConfig}>
          <GenerateAllLessonEditorPlugin
            generateAllMode={generateAllMode}
            ganrateLesson={ganrateLesson}
            generateAllRubricEditorSync={generateAllRubricEditorSync}
            setGenerateAllRubricEditorSync={setGenerateAllRubricEditorSync}
            setGenerateAllMode={setGenerateAllMode}
            TabToBottom={TabToBottom}
            activeWorkboard={activeWorkboard}
            setShowCourseSuccessfully={setShowCourseSuccessfully}
          />
          <section className="lesson_generator lesson-generator-page">
            <div className="container-fluid">
              <div className="row">
                <div className="col-lg-12 col-md-12">
                  <div className="lesson_generator_inner">
                    <div className="view-course-Details-back-btn-folder mb-0">
                      <div
                        className="Back_button"
                        onClick={handleBack}
                        style={{
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                          color: "#0068ff",
                          cursor: "pointer",
                          marginBottom: "26px",
                        }}
                      >
                        <i className="fa-solid fa-chevron-left"></i>
                        <span style={{ padding: " 0px 5px" }}>
                          Lesson Generator
                        </span>
                      </div>
                    </div>


                    <div className="assign_main_box">
                      <div className="assign_main_box_left">
                        <div className="assign_main_box_left_single">
                          <label>Lesson Name</label>
                          <CommonTextField
                            type="text"
                            placeholder="E.g. Neurons"
                            name="name"
                            label="Lesson name"
                            showLabel={false}
                            variant="outlined"
                            validate={(val) => isRequired(val, "Lesson name")}
                            size="sm"
                            className="custom-text-field"
                            value={formState.name || ""}
                            onChange={handleInputChange}
                            borderRadius={"6px"}
                            height={45}
                            border={"1px solid #ECECEC;"}
                            color="neutral"
                          />
                          {formState.name && formState.name.length > 75 && (
                            <div
                              style={{
                                color: "red",
                                fontSize: "12px",
                                padding: "5px 0 0 0",
                              }}
                            >
                              Lesson name cannot exceed 75 characters.
                            </div>
                          )}
                          {hasRestrictedChars && (
                            <div
                              style={{
                                color: "red",
                                fontSize: "12px",
                                padding: "5px 0 0 0",
                              }}
                            >
                              Characters + % & # are not allowed
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="assign_main_box_right">
                        <div className="assign_main_box_right_single">
                          <label>Lesson Start Date</label>

                          <div className="assing_cal_sec_new">
                            <img src={Calimg} className="cal_img_sec" alt="" />
                            <Datetime
                              isValidDate={isValidDateLessonStartDate}
                              min={lessonMinDate}
                              max={
                                course?.end_date === ""
                                  ? null
                                  : dayjs(course?.end_date)
                              }
                              timeFormat={false}
                              inputProps={{
                                placeholder: "MM:DD:YYYY",
                                readOnly: true,
                              }}
                              closeOnSelect={true}
                              dateFormat="MMM DD, YYYY"
                              placeholder="E.g. Sep 10, 2023"
                              name="start_date"
                              value={
                                formState.start_date
                                  ? dayjs(formState.start_date).format(
                                    "MMM DD, YYYY",
                                  )
                                  : ""
                              }
                              onChange={(date) =>
                                handleInputChangedate("start_date", date)
                              }
                              className="custom-datetime"
                            />
                          </div>

                          <div className="warning-message">
                            {formLessonError?.start_date}
                          </div>
                        </div>
                        <div className="assign_main_box_right_single lesson-end-date">
                          <label>Lesson End Date</label>
                          <div className="assing_cal_sec_new">
                            <img src={Calimg} className="cal_img_sec" alt="" />
                            <Datetime
                              isValidDate={isValidDateLessonEndDate}
                              max={dayjs(course?.end_date)}
                              timeFormat={false}
                              inputProps={{
                                placeholder: "MM:DD:YYYY",
                                readOnly: true,
                              }}
                              closeOnSelect={true}
                              dateFormat="MMM DD, YYYY"
                              placeholder="E.g. Sep 10, 2023"
                              name="end_date"
                              value={
                                formState.end_date
                                  ? dayjs(formState.end_date).format(
                                    "MMM DD, YYYY",
                                  )
                                  : ""
                              }
                              onChange={(date) =>
                                handleInputChangedate("end_date", date)
                              }
                              className="custom-datetime"
                            />
                          </div>

                          <div className="warning-message">
                            {formLessonError?.end_date}
                          </div>
                        </div>
                        <div className="assign_main_box_right_single lesson-end-date">
                          <label>Files</label>
                          {/* Tooltip anchors on the wrapper: a disabled button doesn't fire hover events. */}
                          <MuiTooltip
                            // title={
                            //   generationType === GenerationType.STORY.value
                            //     ? "Story generation doesn’t support file uploads"
                            //     : ""
                            // }
                            placement="top"
                            arrow
                          >
                            <div className="assing_cal_sec_new">
                              <UploadFileBtn
                                handleClick={() => openRepoModal("uploadFile", course)}
                                label={course?.aggregated_file_count ? `Course Files (${course.aggregated_file_count})` : "Course Files"}
                                variant="lessonGenerator"
                                // disabled={generationType === GenerationType.STORY.value}
                              />
                            </div>
                          </MuiTooltip>
                        </div>
                        {pop_up_for_lesson_start_date_note && (
                          <div className="pop_up_for_lesson_start_date_note">
                            <p>
                              Students can start accessing the course content
                              from{" "}
                              {dayjs(formState.start_date).format(
                                "MMM DD, YYYY",
                              )}
                            </p>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="lesson-generator-massege-folder">
                    <h6>Workboard</h6>
                    {generationType !== GenerationType?.STORY?.value && (
                      <div className="lesson-generator-all-toggle-flex">
                        <div className="lesson-genrater-toggle-folder">
                          <div className="Preview-lesson-text-editor-features-personalize">
                            <h2>ChatBot</h2>

                            {
                              toggleLoader === "ChatBot" ? <div style={{ display: "flex", alignItems: "center", justifyContent: "center", width: 36 }}>
                                <div style={{ transform: "scale(0.7)" }}>
                                  <LoaderComponent />
                                </div>
                              </div> :
                                <label className="switch">
                                  <input
                                    type="checkbox"
                                    checked={isSwitchOnVirtualAssistant}
                                    onClick={handleSwitchToggleVirtualAssistant}
                                  />
                                  <span className="slider round"></span>
                                </label>
                            }
                          </div>
                          <img
                            src={tooltip}
                            alt="tooltip"
                            data-tooltip-id="chatbot-data-workboard"
                            style={{ cursor: "pointer", marginLeft: "4px" }}
                          />
                          <Tooltip
                            id="chatbot-data-workboard"
                            place="top"
                            content="Show/Hide chatbot during assignments"
                          />
                        </div>

                        <div className="lesson-genrater-toggle-folder">
                          <div className="Preview-lesson-text-editor-features-personalize">
                            <h2
                              style={{
                                opacity: hideTimerDisabled ? 0.5 : 1,
                                color: hideTimerDisabled ? "#B3B3B3" : "black",
                              }}
                            >
                              Hide Timer
                            </h2>

                            {
                              toggleLoader === "Hide Timer" ? <div style={{ display: "flex", alignItems: "center", justifyContent: "center", width: 36 }}>
                                <div style={{ transform: "scale(0.7)" }}>
                                  <LoaderComponent />
                                </div>
                              </div>
                                :
                                <label className={`switch ${hideTimerDisabled ? "disabled-toggle" : ""}`}>
                                  <input
                                    type="checkbox"
                                    checked={currentHideTimerState}
                                    onClick={handleSwitchToggleHideTimer}
                                    disabled={hideTimerDisabled}
                                  />
                                  <span
                                    style={{
                                      cursor: hideTimerDisabled
                                        ? "not-allowed"
                                        : "pointer",
                                      color: Assignmentgeneration ? "black" : "",
                                    }}
                                    className="slider round"
                                  ></span>
                                </label>
                            }

                          </div>

                          <img
                            src={tooltip}
                            alt="tooltip"
                            data-tooltip-id="hidetimer-tooltip"
                            style={{ cursor: "pointer", marginLeft: "4px" }}
                          />
                          <Tooltip
                            id="hidetimer-tooltip"
                            place="top"
                            content="Hide timer for students during assignments"
                          />
                        </div>

                        {/* <div className="Preview-lesson-Content">
                        <div className="Preview-lesson-text-editor-features-personalize">
                          <h2>Personalize</h2>

                          {
                            toggleLoader === "Personalize" ? <div style={{ display: "flex", alignItems: "center", justifyContent: "center", width: 36 }}>
                              <div style={{ transform: "scale(0.7)" }}>
                                <LoaderComponent />
                              </div>
                            </div> :
                              <label className="switch">
                                <input
                                  type="checkbox"
                                  checked={isSwitchOn}
                                  onClick={handleSwitchToggle}
                                />
                                <span className="slider round"></span>
                              </label>
                          }

                          {showPopup && (
                            <p className="personlized_popup">
                              The content will be personalized to match the
                              student's specific interests
                            </p>
                          )}
                        </div>
                        <img
                          src={tooltip}
                          alt="tooltip"
                          data-tooltip-id="personalize-tooltip"
                          style={{ cursor: "pointer", marginLeft: "4px" }}
                        />
                        <Tooltip
                          id="personalize-tooltip"
                          place="top"
                          content="Enable to allow students to see personalized content based on their preferences and interests. "
                        />
                      </div> */}
                        <div className="lesson-genrater-toggle-folder">
                          <div className="Preview-lesson-text-editor-features-personalize">
                            {/* <h2
                              style={{
                                cursor: Assignmentgeneration
                                  ? "not-allowed"
                                  : "pointer",
                                opacity: Assignmentgeneration ? 0.5 : 1, // Set opacity to 0.5 when disabled
                                color: Assignmentgeneration ? "black" : "",
                              }}
                            > */}
                            <h2
                              style={{
                                cursor: "pointer",
                                opacity: 1, // Set opacity to 0.5 when disabled
                              }}
                            >
                              Lesson Preview
                            </h2>


                            {toggleLoader === "Lesson Preview" ? (
                              <div style={{ display: "flex", alignItems: "center", justifyContent: "center", width: 36 }}>
                                <div style={{ transform: "scale(0.7)" }}>
                                  <LoaderComponent />
                                </div>
                              </div>
                            ) : (
                              <label className="switch">
                                <input
                                  type="checkbox"
                                  checked={isSwitchOnLessonPreview}
                                  onClick={handleSwitchToggleLessonPreview}
                                  // disabled={Assignmentgeneration}
                                />
                                <span
                                  style={{
                                    cursor:  "pointer",
                                    // color: Assignmentgeneration ? "black" : "",
                                  }}
                                  className="slider round"
                                ></span>
                              </label>
                            )}
                          </div>
                          <img
                            src={tooltip}
                            alt="tooltip"
                            data-tooltip-id="lessonpreview-data-workboard"
                            style={{ cursor: "pointer", marginLeft: "4px" }}
                          />
                          <Tooltip
                            id="lessonpreview-data-workboard"
                            place="top"
                            content={
                              Assignmentgeneration
                                ? ""
                                : "Show/Hide lesson preview during assignments"
                            }
                          />
                        </div>

                        <div className="lesson-genrater-downlode">
                          <div className="Preview-lesson-text-editor-features-personalize">
                            <h2
                              style={{
                                cursor: Assignmentgeneration
                                  ? "not-allowed"
                                  : "pointer",
                                opacity: Assignmentgeneration ? 0.5 : 1, // Set opacity to 0.5 when disabled
                                color: Assignmentgeneration ? "black" : "",
                              }}
                            >
                              Download Files
                            </h2>

                            {
                              toggleLoader === "Download Files" ?
                                <div style={{ display: "flex", alignItems: "center", justifyContent: "center", width: 36 }}>
                                  <div style={{ transform: "scale(0.7)" }}>
                                    <LoaderComponent />
                                  </div>
                                </div> :
                                <label className="switch">
                                  <input
                                    type="checkbox"
                                    checked={isSwitchOn2}
                                    onClick={handleSwitchToggleDownload}
                                    disabled={Assignmentgeneration}
                                  />
                                  <span
                                    style={{
                                      cursor: Assignmentgeneration
                                        ? "not-allowed"
                                        : "pointer",
                                      color: Assignmentgeneration ? "black" : "",
                                    }}
                                    className="slider round"
                                  ></span>
                                </label>
                            }

                          </div>
                          <img
                            src={tooltip}
                            alt="tooltip"
                            data-tooltip-id="filedownload-data-workboard"
                            style={{ cursor: "pointer", marginLeft: "4px" }}
                          />
                          <Tooltip
                            id="filedownload-data-workboard"
                            place="top"
                            content={
                              sessionStorage.getItem("skipLesson") === "true"
                                ? ""
                                : "Allow download of uploaded files"
                            }
                          />
                        </div>
                      </div>)}
                    <div
                      className="create-lesson-Personalize-contaiber"
                    >
                      {generationType !== GenerationType?.STORY?.value && (
                        <>
                          <img src={preview} alt="preview-img" />
                          <div className="Preview-lesson-text-editor-features-personalize">
                            <h2>
                              <a
                                href="#"
                                style={{ color: shouldShowPreview ? "#0068ff " : "grey", cursor: shouldShowPreview ? "pointer" : "not-allowed", }}
                                onClick={(e) => {
                                  e.preventDefault(); // This prevents the default anchor link behavior
                                  if (!shouldShowPreview) return;
                                  showstudentviewDtls();
                                }}
                              >
                                Student Preview
                              </a>
                            </h2>
                          </div> </>)}
                    </div>
                  </div>
                  <div
                    className="lesson_generator_body_sec"
                    ref={bodyRef}
                    style={{ flexDirection: isSmallScreen ? "column" : "row", position: "relative", display: "flex", }}
                  >

                    {isSmallScreen && (
                      <div className="view-lessons-btn-container">
                        {/* The tab is only pointless while the empty state stands in for the lesson body. */}
                        {!shouldShowEmptyLessonPrompt && (
                          <button
                            className={`tab-button ${activeTab === "lesson" ? "active" : ""
                              }`}
                            onClick={() => setActiveTab("lesson")}
                          >
                            Lessons
                          </button>
                        )}
                        <button
                          className={`tab-button ${activeTab === "workboard" ? "active" : ""
                            }`}
                          onClick={() => setActiveTab("workboard")}
                        >
                          Workboard
                        </button>
                      </div>
                    )}
                    <Box
                      className="lesson_generator_body_sec_left_outer"
                      style={{
                        width: isSmallScreen ? "100%" : isLeftPanelOpen ? panelWidth : 0,
                        minWidth: isSmallScreen ? "100%" : isLeftPanelOpen ? panelWidth : 0,
                        flexShrink: 0,
                        overflow: isLeftPanelOpen ? "visible" : "hidden",
                        transition: "width 0.4s cubic-bezier(0.4, 0, 0.2, 1), min-width 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                        position: "relative",
                        background: "transparent",
                      }}
                      sx={{
                        display: {
                          xs: activeTab === "lesson" ? "flex" : "none",
                          lg: "flex",
                        },
                        flexDirection: "column",
                      }}
                    >
                      {/* INNER — stable width, slides in/out independently */}
                      <Box
                        className={`lesson_generator_body_sec_left_inner ${isLeftPanelOpen ? "panel-open" : "panel-closed"}`}
                        sx={{
                          width: isSmallScreen ? "100%" : panelWidth,
                          minWidth: isSmallScreen ? "100%" : panelWidth,  // prevents inner from collapsing
                          height: "100%",
                          display: "flex",
                          flexDirection: "column",
                          transform: isLeftPanelOpen ? "translateX(0)" : "translateX(-100%)",
                          transition: "transform 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                        }}
                      >
                        <div className="lesson_generator_body_sec_left_body">
                          <div className="lesson_generator_body_sec_left_text_part">
                            <h5>
                              <img src={ass_img} alt="" /> Hello Polly, I will
                              assist you to create amazing lesson for your course.
                            </h5>
                          </div>

                          {/* <button type="button" className="scroll-to-bottom-btn">
                          <i class="fa-solid fa-arrow-down"></i>
                        </button> */}

                          {showScrollButton && (
                            <button
                              type="button"
                              className="scroll-to-bottom-btn"
                              onClick={handleScrollClick}
                            >
                              <i className="fa-solid fa-arrow-down"></i>
                            </button>
                          )}

                          <div
                            className="chat-with-ai-lession-container"
                            ref={chatContainerRef}
                            onScroll={handleUserScroll}
                          >
                            {shouldShowStorySetup ? (
                              isStorySetupFloating ? (
                                <div className="story-setup-anchor">
                                  <StorySetup
                                    isFloating
                                    onClose={closeStorySetup}
                                  />
                                </div>
                              ) : (
                                <StorySetup onClose={closeStorySetup} />
                              )
                            ) : <></>}
                            {chatHist.map((chat, index) => {

                              const isThisMessageStreaming = ganrateLesson && index === chatHist.length - 1;
                              return (
                                <div key={index}>
                                  {
                                    (chat.query && chat.query !== "null") && (
                                      <div className="chat-with-ai-lession-user-folder">
                                        <div className="chat-with-ai-lession-user-sned-massege-container">
                                          {chat?.file?.length > 0 ? (
                                            chat?.file.map((file, index) => {
                                              return (
                                                <ListItem
                                                  key={index}
                                                  sx={{
                                                    backgroundColor: "white",
                                                    borderRadius: "6px",
                                                    marginBottom: "8px",
                                                    height: "48px",
                                                  }}
                                                >
                                                  <ListItemIcon>
                                                    <img
                                                      src={file?.type === "yt_link" ? YouTube_Logo : getFileIcon(
                                                        file?.original_name || file?.file_name || file?.title,
                                                      )}
                                                      alt=""
                                                    />
                                                  </ListItemIcon>
                                                  <ListItemText
                                                    primary={file?.type === "yt_link" ? `${file?.title.slice(0, 20)}...` : file?.original_name || file?.file_name}
                                                    secondary={file?.type === "yt_link" ? "Link" : getFileType(
                                                      file?.original_name || file?.file_name,
                                                    )}
                                                  />
                                                </ListItem>
                                              );
                                            })
                                          ) : (
                                            <></>
                                          )}
                                          <p className="text-massege-user">
                                            {chat.query}
                                          </p>
                                        </div>
                                        <div className="send-user-name">
                                          <h2>
                                            {getname(
                                              globalState.teacher_details?.data?.name,
                                            )}
                                          </h2>
                                        </div>
                                      </div>
                                    )
                                  }

                                  <div className="chat-with-ai-lession-user-folder chat-with-ai-lession-AI-message">
                                    <div className="send-user-name">
                                      <h2>AI</h2>
                                    </div>
                                    {chat.answer === "" && (
                                      <>
                                        <div className="wave-text">
                                          <LoadingGenerationComponent
                                            generate={true}
                                          />
                                        </div>
                                      </>
                                    )}
                                    <div className="read-chat-container">
                                      <div className="chat-with-ai-lession-user-sned-massege-container">
                                        {/* <PreprocessAndRenderLatex
                                          content={normalizeLatexToDoubleDollar(
                                            chat.answer,
                                          )}
                                          isBlockMath={true}
                                        // setShowCloseBTN={setShowCloseBTN}
                                        /> */}

                                        {/* <StreamingAnswer
                                          answer={chat.answer}
                                          isStreaming={ganrateLesson && index === chatHist.length - 1}
                                        /> */}


                                        <YoutubeAwareAnswer
                                          answer={chat.answer}
                                          isStreaming={ganrateLesson && index === chatHist.length - 1}
                                        />

                                      </div>
                                      {!(chat.answer === "") && !generateAllMode && (
                                        <div
                                          key={index}
                                          className="copy-past-text-container"
                                        >
                                          <div className="play-pause-btn-lesson-generator flex md:align-center justify-end md:justify-center">
                                            {chatAudioId === chat.uuid &&
                                              texttospeech.isLoading ? (
                                              <span className="flex items-center gap-[5px]">
                                                <CircularProgress size={13} />
                                              </span>
                                            ) : chatAudioId === chat.uuid &&
                                              chatAudioId ===
                                              texttospeech.generatorId &&
                                              texttospeech.success ? (
                                              <AudioPlayer
                                                src={texttospeech.voice.audio_url}
                                                loader={
                                                  <span className="flex items-center gap-[5px]">
                                                    <CircularProgress size={13} />
                                                  </span>
                                                }
                                              />
                                            ) : (
                                              <i
                                                className="fa-solid fa-circle-play"
                                                style={{ cursor: isThisMessageStreaming ? 'not-allowed' : 'pointer' }}
                                                onClick={() => {
                                                  if (isThisMessageStreaming) return;
                                                  generateAIVoice(
                                                    chat.answer,
                                                    chat.uuid,
                                                  )
                                                }}
                                              ></i>
                                            )}
                                          </div>
                                          <div className="flex gap-2 items-center">
                                            <i
                                              data-tooltip-id="copy-data"
                                              style={{ cursor: isThisMessageStreaming ? 'not-allowed' : 'pointer' }}
                                              onClick={() => {
                                                if (isThisMessageStreaming) return;
                                                onCopyClicked(chat, index)
                                              }}
                                              className={"fa-regular fa-clipboard"}
                                            ></i>
                                            <UpdatePlugin
                                              chat={chat}
                                              index={index}
                                              chatHist={chatHist}
                                              scrollToBottom={TabToBottom}
                                              setActiveWorkboard={setActiveWorkboard}
                                              setActiveTab={setActiveTab}
                                              workboards={workboards}
                                              isAssignment={isAssignment}
                                              isRubric={isRubric}
                                              addLineBreaksAroundImages={
                                                addLineBreaksAroundImages
                                              }
                                              formatLatexInHtmlTags={
                                                formatLatexInHtmlTags
                                              }
                                              processLatex={processLatex}
                                              tooltipContent="Add to Workboard"
                                              getSavedYoutubeLinks={getSavedYoutubeLinks}
                                              setGetSpecificAssignmentType={setGetSpecificAssignmentType}
                                              isThisMessageStreaming={isThisMessageStreaming}
                                            />

                                            <Tooltip
                                              id="copy-data"
                                              place="bottom"
                                              content="Copy"
                                              type="light"
                                              effect="float"
                                            />
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              )
                            })}
                            <div ref={messagesEndRef} />
                          </div>

                          <div className="ganrate-lesson-text-feild-wrapper">
                            <div className="pdf_box_sec">
                              <div className="pdf_box_sec_inner">
                                <AWSS3FileDelete
                                  selectedFiles={selectedFiles}
                                  setSelectedFiles={setSelectedFiles}
                                  getFileIcon={getFileIcon}
                                  uploadedFileLink={uploadedFileLink}
                                  setuploadedFileLink={setuploadedFileLink}
                                  progressTracker={progressTracker}
                                  setprogressTracker={setprogressTracker}
                                  fileInputRef={fileInputRef}
                                />
                                <SelectedFiles selectedFiles={selectedRepoFiles} setSelectedFiles={setSelectedRepoFiles} getFileIcon={getFileIcon} />
                                <YoutubeLink
                                  youtubeLinks={youtubeLinks}
                                  setYoutubeLinks={setYoutubeLinks}
                                />
                              </div>
                              {/* bb */}
                              <form
                                onSubmit={(e) => {
                                  if (generateAllMode || ganrateLesson) {
                                    e.preventDefault();
                                    return;
                                  }
                                  sendGenerateLession(e);
                                }}
                              >
                                <div
                                  className={`create-Assignment-container-popup ${checkAssignmentopen
                                    ? ""
                                    : isPopupVisible
                                      ? "show"
                                      : ""
                                    }`}
                                  style={{
                                    padding: `${checkAssignmentopen
                                      ? ""
                                      : isPopupVisible
                                        ? "10px"
                                        : "0px"
                                      }`,
                                  }}
                                >
                                  <div className="create-Assignment-container-popup-folder1">
                                    <div className="assign_main_box_left_single create-Assignment-input-feild">
                                      <label>Assignment Name</label>
                                      <FormControl
                                        margin="0px"
                                        fullWidth
                                        error={!!formErrorAssignmentState.name}
                                      >
                                        <TextField
                                          name="name"
                                          size="small"
                                          defaultValue={""}
                                          placeholder="E.g. Neurons"
                                          className="custom-text-field"
                                          variant="outlined"
                                          value={formAssignmentState.name}
                                          error={!!formErrorAssignmentState.name || hasRestrictedCharsAssignment}
                                          onChange={handleAssignmentInputChange}
                                          onKeyDown={handleassignmentnameKeyPress} // Handle "Enter" key pres
                                          InputProps={{
                                            sx: {
                                              borderRadius: "6px",
                                              backgroundColor: "#FFFFFF",
                                              fontSize: "16px",
                                              height: "35px",
                                            },
                                          }}
                                        />
                                        <FormHelperText sx={{ color: "#d31332" }}>
                                          {formErrorAssignmentState.name}
                                        </FormHelperText>
                                        {hasRestrictedCharsAssignment && (
                                          <FormHelperText sx={{ color: "#d31332" }}>
                                            Characters + % & # are not allowed
                                          </FormHelperText>
                                        )}
                                      </FormControl>
                                    </div>
                                    <div className="Create-Course-inner-input Create-Assignment-dropdown">
                                      <label>Assignment timer</label>
                                      <FormControl margin="none">
                                        <div
                                          className="time-field"
                                          style={{
                                            border: formErrorAssignmentState.duration_minutes
                                              ? "1px solid #d31332"
                                              : undefined,          // keep the CSS default border otherwise
                                            borderRadius: "6px",
                                          }}
                                        >
                                          <button
                                            onClick={(e) => {
                                              e.preventDefault();
                                              assignmentDurationChangeTime(-5);
                                              setAssignmentDurationCount(
                                                Number(assignmentDurationCount) >
                                                  0
                                                  ? Number(
                                                    assignmentDurationCount,
                                                  ) - 1
                                                  : 0,
                                              );
                                            }}
                                          >
                                            -
                                          </button>
                                          <span>
                                            {`${assignmentDuration.minutes
                                              .toString()
                                              .padStart(2, "0")} Minute${assignmentDuration.minutes?.toString() >
                                                1
                                                ? "s"
                                                : ""
                                              }`}
                                          </span>
                                          <button
                                            onClick={(e) => {
                                              e.preventDefault();
                                              assignmentDurationChangeTime(5);
                                              setAssignmentDurationCount(
                                                Number(assignmentDurationCount) +
                                                1,
                                              );
                                            }}
                                          >
                                            +
                                          </button>
                                        </div>

                                        <FormHelperText sx={{ color: "#d31332" }}>
                                          {
                                            formErrorAssignmentState.duration_minutes
                                          }
                                        </FormHelperText>
                                      </FormControl>
                                    </div>
                                  </div>
                                  <div className="create-Assignment-container-popup-folder2">
                                    <div className="assign_main_box_right_date">
                                      <label>Start Date</label>
                                      <FormControl
                                        margin="none"
                                        fullWidth
                                        error={
                                          !!formErrorAssignmentState.start_date
                                        }
                                      >
                                        <img
                                          src={Calimg}
                                          className="cal_img_sec_assignment"
                                          alt=""
                                        />
                                        <Datetime
                                          isValidDate={
                                            isValidDateAssignmentStartDate
                                          }
                                          min={minDate}
                                          timeFormat={false}
                                          inputProps={{
                                            placeholder: "MM:DD:YYYY",
                                            readOnly: true,
                                          }}
                                          closeOnSelect={true}
                                          dateFormat="MMM DD, YYYY"
                                          placeholder="E.g. Sep 10, 2023"
                                          name="start_date"
                                          value={
                                            formAssignmentState.start_date
                                              ? dayjs(
                                                formAssignmentState.start_date,
                                              ).format("MMM DD, YYYY")
                                              : ""
                                          }
                                          onChange={(date) =>
                                            handleAssignmentInputChangedate(
                                              "start_date",
                                              date,
                                            )
                                          }
                                          className="custom-datetime my-custom-picker"
                                        />
                                        <FormHelperText sx={{ color: "#d31332" }}>
                                          {formErrorAssignmentState.start_date}
                                        </FormHelperText>
                                      </FormControl>
                                    </div>
                                    <div className="assign_main_box_right_date">
                                      <label>Expiry Date</label>
                                      <FormControl
                                        margin="none"
                                        fullWidth
                                        error={
                                          !!formErrorAssignmentState.start_date
                                        }
                                      >
                                        <img
                                          src={Calimg}
                                          className="cal_img_sec_assignment"
                                          alt=""
                                        />

                                        <Datetime
                                          isValidDate={
                                            isValidDateAssignmentEndDate
                                          }
                                          min={dayjs(
                                            formAssignmentState?.start_date
                                              ? formState.start_date
                                              : formAssignmentState?.start_date,
                                          )
                                            .add(1, "day")
                                            .format("MMM DD, YYYY")}
                                          timeFormat={false}
                                          inputProps={{
                                            placeholder: "MM:DD:YYYY",
                                            readOnly: true,
                                          }}
                                          closeOnSelect={true}
                                          dateFormat="MMM DD, YYYY"
                                          placeholder="E.g. Sep 10, 2023"
                                          name="end_date"
                                          value={
                                            formAssignmentState.end_date === null
                                              ? ""
                                              : dayjs(
                                                formAssignmentState.end_date,
                                              ).format("MMM DD, YYYY")
                                          }
                                          onChange={(date) =>
                                            handleAssignmentInputChangedate(
                                              "end_date",
                                              date,
                                            )
                                          }
                                          className="custom-datetime my-custom-picker"
                                          initialViewDate={dayjs(
                                            formAssignmentState?.start_date ??
                                            formState.start_date,
                                          )
                                            .add(1, "day")
                                            .toDate()}
                                        />
                                        <FormHelperText sx={{ color: "#d31332" }}>
                                          {formErrorAssignmentState.end_date}
                                        </FormHelperText>
                                      </FormControl>
                                    </div>
                                    <div className="Create-Course-inner-input Create-Assignment-dropdown create-Assignment-popup-input-feild">
                                      <label>Choose Assignment type</label>
                                      <FormControl margin="none">
                                        <TextField
                                          name="type"
                                          defaultValue={"ddasas"}
                                          value={formAssignmentState.type}
                                          placeholder="Select Assignment type"
                                          variant="outlined"
                                          select
                                          size="small"
                                          error={!!formErrorAssignmentState.type}
                                          onChange={handleAssignmentInputChange}
                                          InputProps={{
                                            sx: {
                                              borderRadius: "6px",
                                              backgroundColor: "#FFFFFF",
                                              height: "35px",
                                              padding: "0px",
                                            },
                                          }}
                                        >
                                          {Object.values(AssignmentType).map(
                                            (type) => (
                                              <MenuItem
                                                key={type.name}
                                                value={type.value}
                                              >
                                                {type.name}
                                              </MenuItem>
                                            ),
                                          )}
                                        </TextField>
                                        <FormHelperText sx={{ color: "#d31332" }}>
                                          {formErrorAssignmentState.type}
                                        </FormHelperText>
                                      </FormControl>
                                    </div>
                                  </div>
                                </div>
                                <div className="promote_part_sec">
                                  {
                                    // (activeWorkboard.name === 'Assignment' && !generateAllMode && getassignmentdetails[assignmentsCountTwo]) && (
                                    (activeWorkboard.name === 'Assignment' && !generateAllMode) && (
                                      <div className="flex gap-[10px] items-center" >
                                        <p
                                          onClick={() => {
                                            if (ganrateLesson || getassignmentdetails[assignmentsCountTwo]?.has_submissions) return;
                                            setPopupVisible(!isPopupVisible)
                                          }}
                                          className="cursor-pointer text-[13px] text-[#0068FF] font-medium underline w-fit"
                                          // style={{ color: ganrateLesson && 'grey', cursor: ganrateLesson && 'not-allowed' }}
                                          style={{
                                            color: (ganrateLesson || getassignmentdetails[assignmentsCountTwo]?.has_submissions) ? 'grey' : undefined,
                                            cursor: (ganrateLesson || getassignmentdetails[assignmentsCountTwo]?.has_submissions) ? 'not-allowed' : 'pointer',
                                            opacity: getassignmentdetails[assignmentsCountTwo]?.has_submissions ? 0.5 : 1,
                                            pointerEvents: getassignmentdetails[assignmentsCountTwo]?.has_submissions ? 'not-allowed' : 'auto',
                                          }}
                                        >
                                          Edit Assignment Type & Details
                                        </p>
                                        <img src={information} alt="" className="w-[15px] h-[15px]" data-tooltip-id="assignment_edit_tooltip" />
                                        <Tooltip
                                          id="assignment_edit_tooltip"
                                          place="top"
                                          content="Assignment cannot be edited after receiving a submission."
                                          type="light"
                                          effect="float"
                                        />

                                      </div>
                                    )
                                  }
                                  <FileUpload
                                    selectedRepoFiles={selectedRepoFiles}
                                    youtubeLinks={youtubeLinks}
                                    showUploadPop={showUploadPop}
                                    setShowUploadPop={setShowUploadPop}
                                    selectedFiles={selectedFiles}
                                    setSelectedFiles={setSelectedFiles}
                                    setuploadedFileLink={setuploadedFileLink}
                                    fileInputRef={fileInputRef}
                                    popupRef={popupRef}
                                    uploadFromRepo={uploadFromRepo}
                                    setUploadFromRepo={setUploadFromRepo}
                                    disabled={generateAllMode}
                                    imageOnly={isAssignment && !isSkipLesson} // Assignment for a lesson that wasn't skipped: lesson content is the source, so only allow image generation
                                    generateImageOpen={generateImageOpen}
                                    setGenerateImageOpen={setGenerateImageOpen}
                                    defaultYoutubeLink={defaultYoutubeLink}
                                    onYoutubeLinkSubmit={async ({ type, rawUrl, embedUrl, videoId, startSeconds }) => {
                                      // website link: no transcript, just store it
                                      if (type !== "youtube") {
                                        setYoutubeLinks((prev) => [
                                          ...prev,
                                          { uuid: rawUrl, video_title: rawUrl, rawUrl, embedUrl, s3_url: rawUrl },
                                        ]);
                                        return;
                                      }

                                      try {
                                        const { data: res } = await api.post(
                                          "/youtube-transcript/",
                                          { youtube_url: embedUrl }, // 👈 adjust field name to match your backend
                                          {
                                            headers: {
                                              "Content-Type": "application/json",
                                              Authorization: `Token ${token}`,
                                            },
                                          }
                                        );

                                        const d = res?.data || {};
                                        setYoutubeLinks((prev) => [
                                          ...prev,
                                          {
                                            uuid: d.uuid,
                                            video_title: d.video_title || "YouTube video",
                                            rawUrl,
                                            embedUrl,
                                            videoId,
                                            startSeconds,
                                            s3_url: d.s3_url,
                                          },
                                        ]);
                                        // modal closes automatically once this resolves
                                      } catch (err) {
                                        console.error("youtube-transcript failed:", err);
                                        throw err; // keep the modal open + let it surface the error
                                      }
                                    }}
                                  />
                                  <TextField
                                    ref={textBoxRef}
                                    id="lesson_promote_flexible"
                                    name="chat_query"
                                    label=""
                                    variant="standard"
                                    placeholder={`Describe your ${isAssignment
                                      ? "assignment"
                                      : isRubric
                                        ? "rubric"
                                        : "lesson"
                                      } idea here...`}
                                    fullWidth
                                    multiline
                                    InputProps={{
                                      disableUnderline: true,
                                      startAdornment: (
                                        <>
                                          {generationType !== GenerationType.STORY.value &&
                                            <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                              <AttachFileOutlined
                                                className="uplode-icon-generator"
                                                onClick={() => {
                                                  if (generateAllMode) return;
                                                  showUploadPopupcall();
                                                }}
                                                style={{
                                                  cursor: generateAllMode
                                                    ? "not-allowed"
                                                    : "pointer",
                                                  opacity: generateAllMode
                                                    ? 0.45
                                                    : 1,
                                                }}
                                              />

                                              {generateImageOpen && (
                                                <span className="create-image-tag">
                                                  🖼️ Create image
                                                  <span
                                                    style={{
                                                      position: "absolute",
                                                      right: "25px",
                                                      top: "-1px",
                                                      cursor: 'pointer'
                                                    }}
                                                  >

                                                    <i
                                                      // className="fa-solid fa-xmark  absolute right-[-5px] z-[3] !top-[-5px] !text-[14px] !border-r-0 !pr-0 text-black cursor-pointer"
                                                      className="fa-solid fa-xmark"
                                                      onClick={() => setGenerateImageOpen(false)}
                                                    />
                                                  </span>
                                                </span>
                                              )}
                                            </div>}
                                        </>
                                      ),

                                      endAdornment: (
                                        <>
                                          {(showCloseBTN || generateAllMode) && (
                                            <>
                                              {" "}
                                              <button
                                                onClick={closeConnection}
                                                className="genrater-close-btn"
                                              >
                                                <i class="fa-regular fa-circle-stop"></i>
                                              </button>{" "}
                                            </>
                                          )}
                                          {/* hidden while the stop button occupies this slot; lesson tab only */}
                                          {showGenerationTypeMenu && (
                                            <GenerationTypeMenu
                                              value={generationType}
                                              onChange={changeGenerationType}
                                              disabled={isGenerationTypeLocked}
                                              otherOptionsDisabledMessage={savedGenerationTypeMessage}
                                            />
                                          )}
                                          <button
                                            type="button"
                                            id="mic-btn"
                                            className={`mic ${isListening ? "listening" : ""
                                              }`}
                                            disabled={generateAllMode}
                                            style={{
                                              cursor: generateAllMode
                                                ? "not-allowed"
                                                : "pointer",
                                              opacity: generateAllMode
                                                ? 0.45
                                                : 1,
                                            }}
                                            onClick={() => {
                                              if (generateAllMode) return;
                                              startStopListening();
                                            }}
                                          >
                                            <i
                                              className={`fa-solid fa-microphone ${isListening ? "hidden" : ""
                                                }`}
                                            ></i>
                                            <div
                                              className={`boxContainer ${isListening ? "" : "hidden"
                                                }`}
                                            >
                                              <div className="box box1"></div>
                                              <div className="box box2"></div>
                                              <div className="box box3"></div>
                                            </div>
                                          </button>
                                          <Tooltip
                                            id="speack-mic"
                                            place="bottom"
                                            content="Press Alt to unmute Mic"
                                            type="light"
                                            effect="float"
                                          />

                                          <MuiTooltip
                                            title={
                                              isLockedBySubmissions
                                                ? SUBMISSION_LOCKED_MESSAGE
                                                : ""
                                            }
                                            arrow
                                            placement="top"
                                          >
                                            {/* A disabled button fires no mouse
                                                events, so the wrapper has to be
                                                the tooltip anchor. */}
                                            <span>
                                              <button
                                                type="submit"
                                                disabled={
                                                  isLockedBySubmissions ||
                                                  isListening ||
                                                  !formState.chat_query ||
                                                  formState.chat_query === null ||
                                                  formState.chat_query === "" || // Condition 2
                                                  selectedFiles.length !==
                                                  progressTracker.length ||
                                                  reFormatterLoading ||
                                                  ganrateLesson ||
                                                  generateAllMode ||
                                                  hasRestrictedCharsAssignment ||
                                                  !progressTracker.every(
                                                    (obj) =>
                                                      obj.status === "Completed",
                                                  ) // Condition 3
                                                }
                                                className="go_cls_btn"
                                              >
                                                <img src={go_btn} alt="" />
                                              </button>
                                            </span>
                                          </MuiTooltip>
                                        </>
                                      ),
                                    }}
                                    maxRows={5}
                                    value={
                                      isListening
                                        ? formState.chat_query
                                          ? `${formState.chat_query}${transcript ? ` ${transcript}` : ""
                                          }`
                                          : transcript
                                        : formState.chat_query
                                    }
                                    disabled={isListening}
                                    // narrows the textarea so it clears the generation-type chip
                                    inputProps={{
                                      className: showGenerationTypeMenu
                                        ? "has-generation-type-input"
                                        : "",
                                    }}
                                    onChange={handleInputKeyPress}
                                    onKeyDown={handleInputKeyPress}
                                  />
                                  <UploadFromRepoModal
                                    setSelectedRepoFiles={setSelectedRepoFiles}
                                    selectedRepoFiles={selectedRepoFiles}
                                    selectedNormalFiles={selectedFiles}
                                    open={uploadFromRepo}
                                    setOpen={setUploadFromRepo}
                                  />
                                  <Tooltip
                                    id="my-tooltip-click"
                                    content="Prompt here"
                                    events={["click"]}
                                  />
                                </div>
                              </form>
                            </div>
                          </div>
                          <p className="AI-disclamer">
                            AI can make mistakes. Consider checking important
                            information
                          </p>
                        </div>
                      </Box>
                    </Box>
                    <Box
                      className="lesson_generator_body_sec_right"
                      sx={{
                        // width: isSmallScreen ? "100%" : "100%",
                        flex: 1,
                        minWidth: 0,
                        width: "100%",
                        position: "relative",
                        display: {
                          xs: activeTab === "workboard" ? "block" : "none",
                          lg: "block",
                        },
                      }}
                    >
                      {!isSmallScreen && (
                        <button
                          type="button"
                          // Nothing to open the panel onto only while the empty
                          // state is up — an unsaved conversation still counts.
                          disabled={shouldShowEmptyLessonPrompt}
                          onClick={() => setIsLeftPanelOpen(prev => !prev)}
                          title={isLeftPanelOpen
                            ? "Close AI panel"
                            : "Open AI panel"
                          }
                          className="
                          absolute left-0 top-[37%] -translate-y-1/2 z-10
                          w-[30px] h-[85px]
                          bg-[#e5f5ff]
                          border border-gray-300 border-l-0
                          rounded-r-md
                          cursor-pointer
                          disabled:opacity-40 disabled:cursor-not-allowed
                          flex items-center justify-center
                          p-0
                          z-[1]"
                        >
                          <ArrowLeftIcon
                            style={{
                              fontSize: 40,
                              color: "#0068ff",
                              transition: "transform 0.38s cubic-bezier(0.4,0,0.2,1)",
                              transform: isLeftPanelOpen ? "rotate(0deg)" : "rotate(180deg)",
                            }}
                          />
                        </button>
                      )}
                      <div className="lesson_generator_body_sec_right_body">
                        <div className="lesson_generator_editor_toos-folder"
                          style={{ justifyContent: isLeftPanelOpen ? "space-between" : "space-around", justifyContent: !isLeftPanelOpen && "center", gap: !isLeftPanelOpen && "30px" }}
                        >
                          {generationType === GenerationType.STORY.value ? <>
                            {/* <div className="flex items-center justify-between"> */}
                            <span className="text-[#555555] font-medium text-[0.8rem]">Story Shell</span>

                            {/* </div> */}
                          </> : (
                            <>
                              <UpdateActiveWorkbaordPlugin
                                generateAllMode={generateAllMode}
                                sendGenerateLession={sendGenerateLession}
                                syncEditorActiveWorkboardName={
                                  syncEditorActiveWorkboardName
                                }
                                assignmentsCount={assignmentsCount}
                                setAssignmentCounts={setAssignmentCounts}
                                showAssingment={showAssingment}
                                setShowAssingment={setShowAssingment}
                                selectedAssignment={selectedAssignment}
                                setSelectedAssignment={setSelectedAssignment}
                                isPopupVisible={isPopupVisible}
                                setPopupVisible={setPopupVisible}
                                setIsAssignment={setIsAssignment}
                                onChangeAssignmentData={onChangeAssignmentData}
                                setOnChangeAssignmentData={
                                  setOnChangeAssignmentData
                                }
                                setAssignmentCountsTwo={setAssignmentCountsTwo}
                                editWorkboardStatues={editWorkboardStatues}
                                setEditWorkboardStatues={setEditWorkboardStatues}
                                assignmentsCountTwo={assignmentsCountTwo}
                                showDropdownRubric={showDropdownRubric}
                                setShowDropdownRubric={setShowDropdownRubric}
                                rubricCount={rubricCount}
                                setRubricCount={setRubricCount}
                                rubricCounttTwo={rubricCounttTwo}
                                setRubricCountTwo={setRubricCountTwo}
                                onChangeRubricData={onChangeRubricData}
                                setOnChangeRubricData={setOnChangeRubricData}
                                selectedRubric={selectedRubric}
                                setSelectedRubric={setSelectedRubric}
                                previesCountAssignment={previesAssignment}
                                setPreviesAssignment={setPreviesAssignment}
                                setPreviesRubric={setPreviesRubric}
                                setFormAssignmentState={setFormAssignmentState}
                                updateFuntion={updateFuntion}
                                setUpdateFuntion={setUpdateFuntion}
                                isRubricConfirmModalData={isRubricConfirmModalData}
                                setIsRubricConfirmModalData={
                                  setIsRubricConfirmModalData
                                }
                                afterConfirmation={afterConfirmation}
                                setAfterConfirmation={setAfterConfirmation}
                                isAssingmentConfirmModalData={
                                  isAssingmentConfirmModalData
                                }
                                setIsAssingmentConfirmModalData={
                                  setIsAssingmentConfirmModalData
                                }
                                callAddAssignmentFun={callAddAssignmentFun}
                                setCallAddAssignmentFun={setCallAddAssignmentFun}
                                callSwitchToRubricFun={callSwitchToRubricFun}
                                setCallSwitchToRubricFun={setCallSwitchToRubricFun}
                                pendingAssignmentClickArgs={
                                  pendingAssignmentClickArgs
                                }
                                setPendingAssignmentClickArgs={
                                  setPendingAssignmentClickArgs
                                }
                                setActiveWorkboard={setActiveWorkboard}
                                workboards={workboards}
                                defaultWorkboardData={defaultWorkboardData}
                                updateWorkboardDataByName={
                                  updateWorkboardDataByName
                                }
                                lesson={lesson}
                                setFormState={setFormState}
                                setIsRubric={setIsRubric}
                                lessonbuttonStyle={lessonbuttonStyle}
                                globleOnChange={globleOnChange}
                                setGlobleOnChange={setGlobleOnChange}
                                updateGlobleOnChangeData={updateGlobleOnChangeData}
                                globleSaveData={globleSaveData}
                                assignmentDurationCount={assignmentDurationCount}
                                assignmentDurationChangeTime={
                                  assignmentDurationChangeTime
                                }
                                setAssignmentDuration={setAssignmentDuration}
                                setAssignmentDurationCount={
                                  setAssignmentDurationCount
                                }
                                checkAssignmentopen={checkAssignmentopen}
                                setEachAssignment_id={setEachAssignment_id}
                                setassignment_id={setassignment_id}
                                formAssignmentState={formAssignmentState}
                                setShowRubricPopUp={setShowRubricPopUp}
                                setswitchschoologySync={setswitchschoologySync}
                                setEachRubric_id={setEachRubric_id}
                                setrubric_id={setrubric_id}
                                Assignmentgeneration={Assignmentgeneration}
                                getassignmentdetails={getassignmentdetails}
                                clickSaveBTN={clickSaveBTN}
                                setClickSaveBTN={setClickSaveBTN}
                                clickSaveRubricBTN={clickSaveRubricBTN}
                                setClickSaveRubricBTN={setClickSaveRubricBTN}
                                setGlobleOnChangeDataSave={
                                  setGlobleOnChangeDataSave
                                }
                                formErrorAssignmentState={formErrorAssignmentState}
                                setFormErrorAssignmentState={
                                  setFormErrorAssignmentState
                                }
                                updateDefaultWorkboardData={
                                  updateDefaultWorkboardData
                                }
                                setActiveTab={setActiveTab}
                                setShowDropdown={setShowDropdown}
                                activeWorkboard={activeWorkboard}
                                isAssignment={isAssignment}
                                isRequired={isRequired}
                                reFormatterLoading={reFormatterLoading}
                                formState={formState}
                                typeChanged={typeChanged}
                                setTypeChanged={setTypeChanged}
                                setGetSpecificAssignmentType={setGetSpecificAssignmentType}
                              />
                            </>
                          )}
                          <div className="all-editer-tools-section">
                            {generationType === GenerationType.STORY.value ? (
                              <>
                                {/* There is nothing to preview until the story has
                                    been generated and saved — the lesson_id alone
                                    exists from lesson creation onwards. */}
                                <MuiTooltip
                                  title="Click here to view the student preview"
                                  open={showStoryPreviewHint}
                                  arrow
                                  placement="top"
                                  slotProps={{
                                    // Default popper is portalled at z-index
                                    // 1500, so it stayed pinned over the header
                                    // once the button scrolled away. Rendering
                                    // it in place, under every layered element,
                                    // keeps it attached to the button instead.
                                    popper: {
                                      disablePortal: true,
                                      sx: { zIndex: 1 },
                                    },
                                  }}
                                >
                                  {/* The wrapper is the tooltip anchor — a
                                      disabled button fires no mouse events. */}
                                  <span
                                    ref={storyPreviewBtnRef}
                                    className="inline-flex"
                                  >
                                    <PrimaryBtn
                                      icon={<EyeIcon width={16} height={12} />}
                                      py="py-[8px]"
                                      label="Student Preview"
                                      disabled={!isStoryPreviewAvailable}
                                      handleClick={() => {
                                        if (!isStoryPreviewAvailable) return;
                                        setShowStoryPreviewHint(false);
                                        setIsStoryPreviewOpen(true);
                                      }}
                                    />
                                  </span>
                                </MuiTooltip>
                                <StoryPreview
                                  open={isStoryPreviewOpen}
                                  onClose={() => setIsStoryPreviewOpen(false)}
                                  lessonId={lesson_id}
                                  lowerSchool={
                                    generationType === GenerationType.STORY.value
                                  }
                                />
                              </>
                            ) : <></>}
                            {/* {generationType !== GenerationType?.STORY?.value && ( */}
                              <span
                                onClick={() => {
                                  if (!shouldShowPreview) return;
                                  openModal();
                                }}
                                style={{ cursor: shouldShowPreview ? "pointer" : "not-allowed", }}
                              >
                                <i
                                  className="fa-solid fa-download"
                                  data-tooltip-id="download-data-workboard"
                                ></i>
                                <Tooltip
                                  id="download-data-workboard"
                                  place="top"
                                  content="Download"
                                  type="light"
                                  effect="float"
                                />
                              </span>
                              {/* )} */}

                            {showDropdown && (
                              <div className="view-course-details-share-form">
                                <div
                                  className="view-course-details-share-folder"
                                  data-aos="zoom-in"
                                >
                                  <h2>Share Lesson</h2>
                                  <div className="view-course-details-inner-wrapper">
                                    <p>Share this link via</p>
                                    <div className="view-course-social-links-folder">
                                      {showDropdown && (
                                        <GoogleDocFile
                                          nameValue={formState.name}
                                        />
                                      )}
                                    </div>

                                    <i
                                      id="create-lesson-share-canle-btn"
                                      className="fa-solid fa-xmark shocial-cross-btn"
                                    />
                                  </div>
                                </div>
                              </div>
                            )}

                            {showDownloadFile && (
                              <div
                                ref={modalRef}
                                className="Download-File-popup-wrappper"
                                id="create-lesson-downloode-wrapper"
                              >
                                <div
                                  ref={modalContentRef}
                                  className="Download-File-popup-container"
                                  data-aos="zoom-in"
                                >
                                  <div className="download-popup">
                                    <h2>Download File as</h2>
                                    <button
                                      className="close-btn"
                                      onClick={toggledownlodefile}
                                    >
                                      ×
                                    </button>
                                    <div className="input-section">
                                      <label>
                                        File Name
                                        <input
                                          type="text"
                                          name="namefiletodnld"
                                          placeholder="Enter File Name"
                                          value={fileNameDownload}
                                          onChange={handleFileNameChange}
                                        />
                                        {fileNameError && (
                                          <p style={{ color: "red" }}>
                                            {fileNameError}
                                          </p>
                                        )}
                                      </label>
                                    </div>
                                    <div className="button-section">
                                      <button
                                        className="spreadsheet-btn"
                                        onClick={exportToWord}
                                        disabled={downloadLoading}
                                        style={{
                                          display: "inline-flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          gap: "8px",
                                          cursor: downloadLoading ? "not-allowed" : "pointer",
                                          opacity: downloadLoading ? 0.75 : 1,
                                          color: downloadLoading ? 'grey' : '#0068ff'
                                        }}
                                      >
                                        {downloadLoading && (
                                          <span
                                            aria-hidden="true"
                                            style={{
                                              width: "14px",
                                              height: "14px",
                                              border: "2px solid #ffffff",
                                              borderTopColor: "transparent",
                                              borderRadius: "50%",
                                              display: "inline-block",
                                              flexShrink: 0,
                                              animation: "yt-spin 0.8s linear infinite",
                                            }}
                                          />
                                        )}
                                        <span style={{ color: 'white' }}>{downloadLoading ? "Downloading..." : "PDF"}</span>
                                        {!downloadLoading && (
                                          <i
                                            className="fa-solid fa-file-lines"
                                            style={{ color: "#ffffff", fontSize: "16px" }}
                                          />
                                        )}
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>



                        </div>

                        {
                          shouldShowEmptyLessonPrompt
                            ? (
                              <div className="flex items-center flex-col justify-center gap-3 my-[75px]">
                                <img src={ai_feedback_image} alt="generate_img" />

                                <div className="text-center">
                                  <h5>No content generated yet</h5>
                                  <p>Click Generate All to generate your lesson, Assignment & Rubric</p>
                                </div>

                                <div className="flex gap-4">
                                  <button
                                    type="button"
                                    className="border-[#0068ff] border-solid px-[41px] py-2 bg-[#fff] text-[#0068ff] text-[13px] focus:border-[#0068ff]"
                                    onClick={() => {
                                      setIsLeftPanelOpen(true);
                                      setCreateManuallyMode(true);
                                      setskipLessonSession(true);
                                    }}
                                  >
                                    Create Manually
                                  </button>

                                  <button
                                    type="button"
                                    className="border border-solid px-[41px] py-2 bg-[#0068ff] text-white text-[13px]"
                                    onClick={(e) => {
                                      // Open the panel only once generation is
                                      // accepted, so a validation error leaves
                                      // the workboard exactly as it was.
                                      if (handleGenerateAll(e)) {
                                        setIsLeftPanelOpen(true);
                                      }
                                    }}
                                  >
                                    Generate All
                                  </button>
                                </div>
                              </div>
                            ) :
                            generateAllMode && !stopGenerateAllMode ? (
                              <div className="flex items-center flex-col justify-center gap-3 my-[88px]">
                                <img style={{ width: "252px" }} src={book_animate} alt="book_animate" />

                                {
                                  ganrateLesson ?
                                    <div className="flex flex-col items-center">
                                      <h4 className="font-semibold">{`Generating ${activeWorkboard.name}...`}</h4>
                                      <div
                                        key={currentMessageIndex}
                                        className="text-center animate-[fadeUp_0.6s_ease-out]"
                                      >
                                        <p>
                                          {
                                            GENERATE_ALL_STATUS_MESSAGES[
                                            currentMessageIndex
                                            ]
                                          }
                                        </p>
                                      </div>
                                    </div> :
                                    <div className="flex flex-col items-center">
                                      <h4 className="font-semibold"> Saving all the data... </h4>
                                    </div>
                                }
                              </div>
                            ) : (
                              <div className="editor-container">
                                <div className="workboard-enhance-formatting-wrapper">
                                  <ToolbarPlugin
                                    disableEnhanceText = {generationType === GenerationType?.STORY?.value ? true : false}
                                    showInputTooltip={showInputTooltip}
                                    setShowInputTooltip={setShowInputTooltip}
                                    latextextvalue={latextextvalue}
                                    setLatextextvalue={setLatextextvalue}
                                    oldMathNode={oldMathNode}
                                    oldnodeeditor={oldnodeeditor}
                                    handleEnhanceText={handleEnhanceText}
                                    reFormatterLoading={reFormatterLoading}
                                    reFormatterData={reFormatterData}
                                    setReFormatterData={setReFormatterData}
                                    ganrateLesson={ganrateLesson}
                                    isLeftPanelOpen={isLeftPanelOpen}
                                  />
                                </div>
                                <div className="editor-inner">
                                  <RichTextPlugin
                                    contentEditable={
                                      <ContentEditable className="editor-input" />
                                    }
                                    placeholder={<Placeholder />}
                                  // ErrorBoundary={LexicalErrorBoundary}
                                  />
                                  {activeWorkboard.name === "Rubric" ? (
                                    <OnChangeRubricPlugin
                                      onChangeRubricData={onChangeRubricData}
                                      rubricCounttTwo={rubricCounttTwo}
                                      generateAllMode={generateAllMode}
                                    />
                                  ) : (
                                    <OnChangePlugin
                                      activeWorkboard={activeWorkboard}
                                      editorActiveWorkboardNameRef={
                                        editorActiveWorkboardNameRef
                                      }
                                      globleOnChangeDataSave={globleOnChangeDataSave}
                                      isNotSavePopUp={isNotSavePopUp}
                                      setGlobleOnChangeDataSave={
                                        setGlobleOnChangeDataSave
                                      }
                                      updateGlobleOnChangeData={
                                        updateGlobleOnChangeData
                                      }
                                      updateWorkboardDataByName={
                                        updateWorkboardDataByName
                                      }
                                      setShowInputTooltip={setShowInputTooltip}
                                      setLatextextvalue={setLatextextvalue}
                                      setOldMathNode={setOldMathNode}
                                    />
                                  )}
                                  <HistoryPlugin />
                                  <PastePlugin />
                                  <AutoFocusPlugin />
                                  <ClearEditorPlugin />
                                  <HtmlPlugin
                                    initialHtml={
                                      location.state?.assignment?.assignment
                                        ? location.state?.assignment?.assignment
                                        : showLesson
                                          ? globleSaveData?.ASSIGNMENT?.data?.[
                                            assignmentsCountTwo
                                          ]?.data
                                          : formState?.description === EMPTY_LESSON_PLACEHOLDER_DESCRIPTION ? "" : formState?.description
                                    }
                                    onHtmlChanged={(e) => { }}
                                  />
                                  <CodeHighlightPlugin />
                                  <ListPlugin />
                                  <LinkPlugin />
                                  <AutoLinkPlugin />
                                  <ListMaxIndentLevelPlugin maxDepth={7} />
                                  <MarkdownShortcutPlugin
                                    transformers={TRANSFORMERS}
                                  />
                                  <ImageDeletePlugin /> {/* ✅ add this here */}
                                  <IframeDeletePlugin /> {/* ✅ add this here */}
                                </div>
                              </div>
                            )
                        }

                      </div>

                      <div
                        className="create-all-btns-container"
                        style={{ display: "flex", justifyContent: "flex-end", gap: "12px" }}
                      >
                        {(activeWorkboard.name == "Assignment" && globalState?.enabled_modules.includes('schoology')) && (
                          <>
                            <div
                              style={{
                                width: "auto",
                                minWidth: "max-content",
                                marginRight: "auto",
                              }}
                              className="sync-to-schoology-swich-toogle"
                              data-tooltip-id="sync-to-schoology-swich-toogle"
                            >
                              <span>Sync To Schoology</span>

                              <label className="switch">
                                <input
                                  disabled={
                                    myRole !== "owner" ||
                                    loadingPublishSchoology ||
                                    isSaveChecker ||
                                    workboardText === "" ||
                                    !(
                                      (isAssignment &&
                                        (workboards.ASSIGNMENT.data === "" ||
                                          workboards.ASSIGNMENT.data ===
                                          defaultWorkboardContent ||
                                          defaultWorkboardData.ASSIGNMENT?.data ===
                                          workboards.ASSIGNMENT?.data ||
                                          cleanHtml(workboards.ASSIGNMENT.data) ===
                                          cleanHtml(onChangeAssignmentData[
                                            assignmentsCountTwo
                                          ])
                                          ||
                                          workboardText === ""))
                                      ||
                                      (JSON.parse(
                                        sessionStorage.getItem("lesson_name"),
                                      ) !== null &&
                                        JSON.parse(
                                          sessionStorage.getItem("lesson_name"),
                                        ) === formState.name &&
                                        (workboards.ASSIGNMENT.data ===
                                          defaultWorkboardContent ||
                                          workboards.ASSIGNMENT.data === ""
                                          ||
                                          cleanHtml(workboards.ASSIGNMENT.data) ===
                                          cleanHtml(onChangeAssignmentData[
                                            assignmentsCountTwo
                                          ])
                                        ))
                                    ) ||
                                    reFormatterLoading ||
                                    ganrateLesson
                                  }
                                  type="checkbox"
                                  checked={switchschoologySync}
                                  onClick={handleSwitchToggleSchoologySync}
                                />

                                {showloading ? (
                                  <span>
                                    <LoaderComponent />
                                  </span>
                                ) : (
                                  <span className="slider round"></span>
                                )}
                              </label>
                            </div>

                            {myRole !== "owner" ? (
                              <Tooltip
                                id="sync-to-schoology-swich-toogle"
                                place="bottom"
                                content="Only course owners can able to use Schoology sync."
                                type="light"
                                effect="float"
                              />
                            ) : (
                              getassignmentdetails &&
                              !getassignmentdetails[assignmentsCountTwo]?.name && (
                                <Tooltip
                                  id="sync-to-schoology-swich-toogle"
                                  place="bottom"
                                  content="Please save the assignment before enabling this option."
                                  type="light"
                                  effect="float"
                                />
                              )
                            )}
                          </>
                        )}

                        {(skipLessonSession && !isAssignment && !isRubric &&
                          generationType === GenerationType.CONTENT.value) &&
                          <button
                            data-tooltip-id="skip-lesson-tooltip"
                            style={{
                              padding: "20px",
                              width: "auto",
                              color: "#007bff",
                              backgroundColor: "transparent",
                              border: "none",
                              marginRight: "auto",
                              cursor:
                                !formState.name ||
                                  formState.name.trim() === "" ||
                                  showCloseBTN
                                  ? "not-allowed"
                                  : "pointer",
                              opacity:
                                !formState.name ||
                                  formState.name.trim() === "" ||
                                  showCloseBTN
                                  ? 0.5
                                  : 1,
                            }}
                            disabled={
                              hasRestrictedChars ||
                              !formState.name ||
                              formState.name.trim() === "" ||
                              showCloseBTN
                            }
                            onClick={(e) => {
                              setskipLessonflag(true);
                              setskipLesson(true);
                            }}
                          >
                            Skip Lesson
                          </button>
                        }
                        <Tooltip
                          id="skip-lesson-tooltip"
                          place="top"
                          content={
                            !formState.name &&
                            "You cannot skip lesson without Lesson Name"
                          }
                          type="light"
                          effect="float"
                          style={{
                            opacity: 1.5, // Set opacity of the tooltip to 1 (always visible)
                          }}
                        />

                        {SkipLessonflag && <LessonSkipComponent />}


                        {
                          !generateAllMode &&
                          <button style={{ width: isLeftPanelOpen ? "35%" : "15%", minWidth: "max-content", padding: "8px 30px", color: "#007bff", backgroundColor: "transparent", border: "2px solid #007bff", borderRadius: "4px", marginTop: isSaveLoading && "25px" }}
                            onClick={(e) => {
                              sessionStorage.getItem("newlesson")
                                ? navigate(-1)
                                : navigate(
                                  `/course/${location.state?.course?.course_id}/view`,
                                  {
                                    state: {
                                      course: location.state?.course,
                                      teacher_id:
                                        location.state?.teacher_id,
                                    },
                                  },
                                );
                            }}
                          >
                            Back to Course
                          </button>
                        }

                        {
                          isSaveLoading ?
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", width: 36, margin: "0 25px" }}>
                              <div style={{ transform: "scale(0.7)" }}>
                                <LoaderComponent />
                              </div>
                            </div> :
                            <button
                              onClick={(e) => {
                                if (!isNotSavePopUp) {
                                  e.preventDefault();
                                }
                                let schoologystatus = "";
                                setschoologystatus(schoologystatus);
                                if (
                                  currentHideTimerState !==
                                  getassignmentdetails[assignmentsCountTwo]
                                    ?.hide_timer
                                ) {
                                  handleSaveHideTimer();
                                }
                                wasEditingRef.current = isAssignment
                                  ? previesAssignment &&
                                  eachAssignment_id !== null
                                  : isRubric
                                    ? previesRubric && eachRubric_id !== null
                                    : lesson_id !== "";

                                handleAssinmentRubricSubmit(
                                  e,
                                  schoologystatus,
                                  switchschoologySync
                                );
                              }}
                              className="proc_btn_new"
                              style={{
                                width:
                                  activeWorkboard.name == "Assignment"
                                    ? "auto"
                                    : "auto",
                                padding: "8px 30px",
                                minWidth: "max-content"
                              }}
                              disabled={
                                isLockedBySubmissions ||
                                hasRestrictedChars ||
                                (generateAllMode
                                  ||
                                  JSON.parse(sessionStorage.getItem("lesson_name")) !== null &&
                                  JSON.parse(sessionStorage.getItem("lesson_name")) === formState.name
                                  ? isSaveChecker ||
                                  (isAssignment
                                    ? (
                                      JSON.stringify(
                                        getArraySectionData(globleOnChange.ASSIGNMENT)
                                      ) ===
                                      JSON.stringify(
                                        getArraySectionData(globleSaveData.ASSIGNMENT)
                                      )
                                    ) ||
                                    workboards.ASSIGNMENT.data === "" ||
                                    // workboardText === ""
                                    isWorkboardEmpty
                                    : isRubric
                                      ? (
                                        JSON.stringify(
                                          getArraySectionData(globleOnChange.RUBRIC)
                                        ) ===
                                        JSON.stringify(
                                          getArraySectionData(globleSaveData.RUBRIC)
                                        )
                                      ) ||
                                      workboards.RUBRIC.data === "" ||
                                      disabledRubric ||
                                      // workboardText === ""
                                      isWorkboardEmpty
                                      : ((
                                        cleanHtml(getSectionData(globleOnChange.LESSON)) ===
                                        cleanHtml(getSectionData(globleSaveData.LESSON))
                                      ) || (
                                          cleanHtml(getSectionData(globleOnChange.LESSON)) === "" &&
                                          cleanHtml(getSectionData(globleSaveData.LESSON)) ===
                                          "@$%^231#^#a5fgd%532^&amp;4R3&amp;"
                                        ) ||
                                        workboards.LESSON.data === "") ||
                                      workboards.LESSON.data === `<p class="editor-paragraph"><br></p>`
                                  ) ||
                                  // workboardText === "" ||
                                  isWorkboardEmpty ||
                                  reFormatterLoading
                                  : false
                                )}
                            >
                              {
                                JSON.parse(sessionStorage.getItem("lesson_name")) !== null &&
                                  JSON.parse(sessionStorage.getItem("lesson_name")) === formState.name &&
                                  shouldShowPreview
                                  ? isAssignment
                                    ? (
                                      JSON.stringify(
                                        getArraySectionData(globleOnChange.ASSIGNMENT)
                                      ) !==
                                      JSON.stringify(
                                        getArraySectionData(globleSaveData.ASSIGNMENT)
                                      )
                                    )
                                      ? "Save"
                                      : "Saved"
                                    : isRubric
                                      ? (
                                        JSON.stringify(
                                          getArraySectionData(globleOnChange.RUBRIC)
                                        ) !==
                                        JSON.stringify(
                                          getArraySectionData(globleSaveData.RUBRIC)
                                        )
                                      )
                                        ? "Save"
                                        : "Saved"
                                      : (
                                        cleanHtml(getSectionData(globleOnChange.LESSON)) !==
                                        cleanHtml(getSectionData(globleSaveData.LESSON)) &&
                                        !(
                                          cleanHtml(getSectionData(globleOnChange.LESSON)) === "" &&
                                          cleanHtml(getSectionData(globleSaveData.LESSON)) ===
                                          "@$%^231#^#a5fgd%532^&amp;4R3&amp;"
                                        )
                                      )
                                        ? "Save"
                                        : "Saved"
                                  : "Save"
                              }
                            </button>
                        }




                      </div>

                    </Box>
                  </div>
                </div>
              </div>
            </div>

            <Modal
              keepMounted
              open={showCourseSuccessfully}
              // onClose={() => {} }
              aria-labelledby="keep-mounted-modal-title"
              aria-describedby="keep-mounted-modal-description"
            >
              <div className="preview-lession-course-created-successfully-wrapper">
                <div className="Course-created-successfully-container">
                  <div className="Course-created-successfully-folder">
                    <div className="Course-created-successfully-image">
                      <img
                        src={Course_created_successfully_image}
                        alt="Course Created Successfully"
                      />
                    </div>
                    {/* switchschoologySync */}
                    {getschoologystatus ||
                      getschoologystatus === "syncAttemptStart" ||
                      getschoologystatus === "syncDone" ? (
                      <h2>
                        {switchschoologySync
                          ? isAssignment
                            ? "Assignment synced successfully. "
                            : isRubric
                              ? "Rubric "
                              : "Lesson " +
                              "has been " +
                              ((isAssignment
                                ? previesAssignment
                                : isRubric
                                  ? previesRubric
                                  : lesson_id !== "")
                                ? "Sync to Schoology"
                                : "Sync to Schoology") +
                              " successfully"
                          : "Assignment Sync to Schoology disabled successfully"}
                      </h2>
                    ) : (
                      <h2>
                        {generateAllMode ? "Lesson, Assignment and Rubric " : isAssignment
                          ? "Assignment "
                          : isRubric
                            ? "Rubric "
                            : "Lesson "}
                        has been{" "}
                        {
                          generateAllMode ? "created " : lesson.description === EMPTY_LESSON_PLACEHOLDER_DESCRIPTION ? "created " : wasEditingRef.current ? "updated " : "created "
                        }
                        successfully
                      </h2>
                    )}
                  </div>
                </div>
              </div>
            </Modal>
          </section >
        </LexicalComposer >
      </LocalizationProvider >

      {modal === "uploadFile" && (
        <ProfileModal
          open={modal === "uploadFile"}
          close={closeModal}
          course={reqData}
          type={'Lesson'}
          lesson={lesson}
          id={lesson.lesson_id}
          // `lower_school` only comes back from the backend after a save, so
          // story generation disables uploads up front.
          disableUpload={generationType === GenerationType.STORY.value}
        />
      )}
    </div >
  );
};



const MemoLatexBlock = React.memo(
  function MemoLatexBlock({ content }) {
    return <PreprocessAndRenderLatex content={content} isBlockMath={true} />;
  },
  (prev, next) => prev.content === next.content
);

/** Split at the last blank line, keeping $$…$$ pairs and <img …> tags intact. */
function splitStableTail(text) {
  let idx = text.lastIndexOf("\n\n");
  if (idx === -1) return { stable: "", tail: text };

  let stable = text.slice(0, idx);

  // don't cut inside an unclosed $$ … $$ block
  if (((stable.match(/\$\$/g) || []).length) % 2 !== 0) {
    idx = stable.lastIndexOf("\n\n");
    if (idx === -1) return { stable: "", tail: text };
    stable = text.slice(0, idx);
  }

  // don't cut inside a half-streamed <div … (image placeholder)
  const lastDiv = stable.lastIndexOf("<div");
  if (lastDiv !== -1 && stable.indexOf("</div>", lastDiv) === -1) {
    return { stable: "", tail: text };
  }

  // don't cut inside a half-streamed <img …
  const lastImg = stable.lastIndexOf("<img");
  if (lastImg !== -1 && stable.indexOf(">", lastImg) === -1) {
    return { stable: "", tail: text };
  }

  return { stable, tail: text.slice(idx) };
}

// function StreamingAnswer({ answer, isStreaming }) {
//   const normalized = React.useMemo(
//     () => normalizeLatexToDoubleDollar(answer || ""),
//     [answer]
//   );

//   const { stable, tail } = React.useMemo(
//     () =>
//       isStreaming
//         ? splitStableTail(normalized)
//         : { stable: normalized, tail: "" },
//     [normalized, isStreaming]
//   );

//   // hide a trailing half-streamed <img … tag so raw HTML text doesn't flash
//   const safeTail = isStreaming ? tail.replace(/<img[^>]*$/, "") : tail;

//   return (
//     <>
//       {stable !== "" && <MemoLatexBlock content={stable} />}
//       {safeTail !== "" && (
//         <PreprocessAndRenderLatex content={safeTail} isBlockMath={true} />
//       )}
//     </>
//   );
// }


function AnswerParts({ text }) {
  const parts = React.useMemo(() => splitPendingImages(text), [text]);
  return (
    <>
      {parts.map((p, i) =>
        p.kind === "pending" ? (
          <LessonImageSkeleton key={p.id || `pending-${i}`} concept={p.concept} />
        ) : (
          <PreprocessAndRenderLatex key={`text-${i}`} content={p.value} isBlockMath={true} />
        ),
      )}
    </>
  );
}

const MemoAnswerBlock = React.memo(
  function MemoAnswerBlock({ content }) {
    return <AnswerParts text={content} />;
  },
  (prev, next) => prev.content === next.content,
);

function StreamingAnswer({ answer, isStreaming }) {
  const normalized = React.useMemo(
    () => normalizeLatexToDoubleDollar(answer || ""),
    [answer],
  );

  const { stable, tail } = React.useMemo(
    () => (isStreaming ? splitStableTail(normalized) : { stable: normalized, tail: "" }),
    [normalized, isStreaming],
  );

  const safeTail = isStreaming ? tail.replace(/<img[^>]*$/, "") : tail;
  const { body, partial } = isStreaming
    ? splitTrailingPartial(safeTail)
    : { body: safeTail, partial: null };

  return (
    <>
      {stable !== "" && <MemoAnswerBlock content={stable} />}
      {body !== "" && <AnswerParts text={body} />}
      {partial && (
        <LessonImageSkeleton key={partial.id || "pending-tail"} concept={partial.concept} />
      )}
    </>
  );
}

// function LessonImageSkeleton({ concept }) {
//   return (
//     <div className="lesson-image-skeleton" role="status" aria-live="polite">
//       <div className="lesson-image-skeleton__shimmer" />
//       <span className="lesson-image-skeleton__label">
//         {concept ? `Generating diagram: ${concept}…` : "Generating diagram…"}
//       </span>
//     </div>
//   );
// }
function LessonImageSkeleton({ concept }) {
  return (
    <div
      className="lesson-image-skeleton"
      role="status"
      aria-label={concept ? `Generating image: ${concept}` : "Generating image"}
    >
      <span className="lesson-image-skeleton__label">Generating Image</span>
    </div>
  );
}

// ── YouTube video + timestamp buttons inside a chat answer ──────────────────
const YT_IFRAME_RE =
  /<iframe\b[^>]*\bsrc=["']([^"']*youtube(?:-nocookie)?\.com\/embed\/[^"']*)["'][^>]*>\s*(?:<\/iframe>)?/gi;


// Split the answer into ordered text / video segments so React owns every YouTube
// iframe (needed for seek/pause) and each video stays where the AI placed it.
const splitYoutubeFromAnswer = (answer) => {
  // AI emits JSX-style className; as raw HTML that becomes "classname" and never matches CSS/selectors
  const text = (answer || "").replace(/\bclassName="youtube_timestamp"/g, 'class="youtube_timestamp"');
  const segments = [];
  let cursor = 0;

  for (const match of text.matchAll(YT_IFRAME_RE)) {
    segments.push({ type: "text", value: text.slice(cursor, match.index) });
    segments.push({
      type: "video",
      src: withYoutubeJsApi(match[1]), // required for postMessage seekTo/pause
      videoId: getYoutubeVideoId(match[1]),
    });
    cursor = match.index + match[0].length;
  }

  // hide a half-streamed "<iframe ..." / stray "</iframe>" so raw tag text doesn't flash
  const rest = text
    .slice(cursor)
    .replace(/^\s*<\/iframe>/i, "")
    .replace(/<iframe\b[^>]*$/i, "");
  segments.push({ type: "text", value: rest });
  return segments;
};

// One embedded player. Wheel events over a cross-origin iframe go to YouTube and are
// chained back to our scroller, which lags — so while an ancestor is scrolling, raise a
// transparent shield over the iframe; drop it once scrolling stops so it's clickable again.
function YoutubeEmbed({ src, videoId }) {
  const shieldRef = useRef(null);

  useEffect(() => {
    let timer = null;
    const onScroll = (e) => {
      const shield = shieldRef.current;
      if (!shield || !(e.target instanceof Node) || !e.target.contains(shield)) return;
      shield.style.pointerEvents = "auto";
      clearTimeout(timer);
      timer = setTimeout(() => {
        if (shieldRef.current) shieldRef.current.style.pointerEvents = "none";
      }, 200);
    };
    // scroll doesn't bubble — capture on document catches the chat container's scroll
    document.addEventListener("scroll", onScroll, { capture: true, passive: true });
    return () => {
      clearTimeout(timer);
      document.removeEventListener("scroll", onScroll, { capture: true });
    };
  }, []);

  return (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", margin: "20px 0" }}>
      <div style={{ position: "relative", maxWidth: "100%", lineHeight: 0 }}>
        <div
          ref={shieldRef}
          data-yt-shield="true"
          aria-hidden="true"
          style={{ position: "absolute", inset: 0, zIndex: 1, pointerEvents: "none" }}
        />
        <iframe
          data-yt-player="true"
          data-yt-id={videoId}
          width="560"
          height="315"
          style={{ maxWidth: "100%", display: "block" }}
          src={src}
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          allowFullScreen
        />
      </div>
    </div>
  );
}

function YoutubeAwareAnswer({ answer, isStreaming }) {
  const wrapperRef = useRef(null);
  const segments = React.useMemo(() => splitYoutubeFromAnswer(answer), [answer]);
  const lastIndex = segments.length - 1;
  // chat panel owns its scroll position (pinning), so jumps must go through the context
  const { scrollChatToElement } = useNewLessons();
  const scrollToRef = useRef(scrollChatToElement);
  scrollToRef.current = scrollChatToElement;

  useEffect(() => {
    const container = wrapperRef.current;
    if (!container) return;

    const onClick = (e) => {
      const btn = e.target.closest(".youtube_timestamp");
      if (!btn || !container.contains(btn)) return;
      e.preventDefault();
      e.stopPropagation();

      const url = btn.getAttribute("data-url") || "";
      const seconds = ytSecondsFromUrl(url, btn.textContent);

      // match this message's video by data-url id, pause every other player on the page
      const iframe = playYoutubeAt(container, url, seconds);

      // video not embedded in this message → just open the link
      if (!iframe) {
        if (url) window.open(url, "_blank", "noopener,noreferrer");
        return;
      }
      // scroll the exact player that was matched (2nd video → scroll to the 2nd video)
      if (scrollToRef.current) scrollToRef.current(iframe);
      else iframe.scrollIntoView({ behavior: "smooth", block: "center" });
    };

    container.addEventListener("click", onClick);
    return () => container.removeEventListener("click", onClick);
  }, []);

  return (
    <div ref={wrapperRef}>
      {segments.map((seg, i) =>
        seg.type === "video" ? (
          <YoutubeEmbed key={`yt-${i}`} src={seg.src} videoId={seg.videoId} />
        ) : seg.value.trim() !== "" || i === lastIndex ? (
          // only the trailing text segment can still be streaming
          <StreamingAnswer
            key={`text-${i}`}
            answer={seg.value}
            isStreaming={isStreaming && i === lastIndex}
          />
        ) : null,
      )}
    </div>
  );
}

export default LessonGenerator;